(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5099],{

/***/ 80819:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/localList.m",
      function () {
        return __webpack_require__(89327);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30202);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32423);
/* harmony import */ var _QUERIES_account_useCustomerMe__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38186);







var withWishList = function(WrappedComponent) {
    return function(props) {
        var ref, ref1;
        var _isActive = props.isActive, isActive = _isActive === void 0 ? false : _isActive, _evCd = props.evCd, evCd = _evCd === void 0 ? "" : _evCd, _link = props.link, link = _link === void 0 ? "" : _link, diviCd = props.diviCd, _wishNo = props.wishNo, wishNo = _wishNo === void 0 ? "" : _wishNo, addConfirm = props.addConfirm, removeConfirm = props.removeConfirm;
        var goodsCd = evCd.split("-")[0];
        var goodsTp = evCd.substring(0, 1);
        /** 로그인 */ var queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQueryClient */ .NL)();
        /** 로그인 */ var signin = (0,_QUERIES_account_useCustomerMe__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)();
        var webCustNo = ((ref = signin.data) === null || ref === void 0 ? void 0 : ref.body.webCustNo) || "";
        var isSignin = ((ref1 = signin.data) === null || ref1 === void 0 ? void 0 : ref1.body.nonUser) === false;
        var addWish = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                var result, _tmp, _tmp1;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = {};
                            return [
                                4,
                                (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((_tmp.url = "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ENV_ESSENTIAL_API_BASEPATH */ .Z.ENV_ESSENTIAL_API_BASEPATH, "/api/customer/wishList"), _tmp.method = "POST", _tmp.data = {
                                    webCustNo: webCustNo,
                                    goodsCd: goodsCd,
                                    goodsNm: "",
                                    evCd: evCd,
                                    diviCd: diviCd,
                                    imageThum: "",
                                    link: "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ENV_PRODUCT_URL */ .Z.ENV_PRODUCT_URL).concat(link),
                                    itemCategoryCode: "".concat(goodsTp === "K" ? "D" : "P"),
                                    cityCode: "",
                                    latestAmount: ""
                                }, _tmp)).catch(function(e) {
                                    throw new Error();
                                })
                            ];
                        case 1:
                            result = _state.sent();
                            _tmp1 = {};
                            if (result.data.code === "0000") {
                                MessageUtil.alert("찜한 상품으로 등록 되었습니다.");
                                queryClient.refetchQueries((_tmp1.queryKey = [
                                    "useWishlist"
                                ], _tmp1.type = "active", _tmp1));
                            } else {
                                throw new Error();
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function addWish() {
                return _ref.apply(this, arguments);
            };
        }();
        var removeWish = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                var result, _tmp, _tmp1;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!wishNo) return [
                                2
                            ];
                            _tmp = {};
                            return [
                                4,
                                (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((_tmp.url = "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ENV_ESSENTIAL_API_BASEPATH */ .Z.ENV_ESSENTIAL_API_BASEPATH, "/api/customer/wishList"), _tmp.method = "DELETE", _tmp.data = {
                                    wishList: [
                                        {
                                            productWishId: wishNo,
                                            webCustNo: webCustNo,
                                            evCd: evCd,
                                            goodsCd: goodsCd,
                                            itemCategoryCode: "P"
                                        }
                                    ]
                                }, _tmp)).catch(function(e) {
                                    throw new Error();
                                })
                            ];
                        case 1:
                            result = _state.sent();
                            _tmp1 = {};
                            if (result.data.code === "0000") {
                                MessageUtil.alert("찜한 상품이 삭제 되었습니다.");
                                queryClient.refetchQueries((_tmp1.queryKey = [
                                    "useWishlist"
                                ], _tmp1.type = "active", _tmp1));
                            } else {
                                throw new Error();
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function removeWish() {
                return _ref.apply(this, arguments);
            };
        }();
        var wish = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(e) {
                var isConfirm, isConfirm1;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!!isActive) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                MessageUtil.confirm("찜한 상품으로 등록하시겠습니까?")
                            ];
                        case 1:
                            isConfirm = _state.sent();
                            if (isConfirm) {
                                addWish();
                                typeof addConfirm === "function" && addConfirm(e);
                            }
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                MessageUtil.confirm("찜한 상품을 삭제하시겠습니까?")
                            ];
                        case 3:
                            isConfirm1 = _state.sent();
                            if (isConfirm1) {
                                removeWish();
                                typeof removeConfirm === "function" && removeConfirm(e);
                            }
                            _state.label = 4;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function wish(e) {
                return _ref.apply(this, arguments);
            };
        }();
        var onClick = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(e) {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    try {
                        if (!evCd) throw new Error("필수 파라미터 누락");
                        if (!isSignin) {
                            MessageUtil.confirm("로그인 후 이용하실 수 있습니다. <br/>로그인하시겠습니까?", function() {
                                return LoginUtil.login();
                            });
                        } else {
                            wish(e);
                        }
                    } catch (e1) {
                        ;
                        MessageUtil.alert("오류가 발생하였습니다. <br/>".concat(e1));
                    }
                    return [
                        2
                    ];
                });
            });
            return function onClick(e) {
                return _ref.apply(this, arguments);
            };
        }();
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, {
                onClick: onClick,
                isActive: props.isActive
            })
        });
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (withWishList);


/***/ }),

/***/ 21679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _QUERIES_prdt_goods_useGoodsDetail__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3081);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var TaggingGTM = function(props) {
    var ref;
    var goodsDetail = (ref = (0,_QUERIES_prdt_goods_useGoodsDetail__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(props.goodsCd).data) === null || ref === void 0 ? void 0 : ref.body;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!goodsDetail) return;
        try {
            dataLayer.push({
                event: "viewContent",
                ecommerce: {
                    detail: {
                        products: [
                            {
                                name: "".concat(goodsDetail.goodsNm),
                                id: "".concat(props.goodsCd),
                                category: "".concat(props.menu)
                            }, 
                        ]
                    }
                }
            });
        } catch (e) {
            ;
        }
    }, [
        goodsDetail
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (TaggingGTM);


/***/ }),

/***/ 64630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPath */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_utils_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42277);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 공통 텍스트 배너조회 API
 *   `/api/bff/link/global/goodsList`
 * parameter
 *      types: string (ex)"live,pang" 여러 타입 조회시 콤마(,)로 구분)
 * ```*/ var key = "useGlobalGoodsFlag";
var getPath = function() {
    return "".concat("https://support.ybtour.co.kr", "/api/bff/link/global/goodsList");
};
/** ```
 * 공통 텍스트 배너조회 API
 *   `/api/bff/link/global/goodsList`
 * parameter
 *      type: string (ex)"PKG,HOTEL,AIR,TOUR" 여러 타입 조회시 콤마(,)로 구분)
 * ```*/ var useGlobalGoodsFlag = function() {
    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "PKG", options = arguments.length > 1 ? arguments[1] : void 0;
    try {
        return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            queryKey: [
                key,
                type,
                getPath()
            ],
            queryFn: function() {
                return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                    url: getPath(),
                    method: "POST",
                    data: {
                        type: type
                    }
                }).then(function(r) {
                    return r.data;
                });
            },
            throwOnError: false
        }, options));
    } catch (error) {
        _FRAMEWORK_utils_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(error);
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (useGlobalGoodsFlag);



/***/ }),

/***/ 61817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPath */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




var key = "useWishlist";
/** ```
 * 위시리스트 조회
 *  `/customer/wishList?webCustNo={webCustNo}`
 * parameter
 * ```*/ var getPath = function(webCustNo) {
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_ESSENTIAL_API_BASEPATH */ .Z.ENV_ESSENTIAL_API_BASEPATH, "/api/customer/wishList?webCustNo=").concat(webCustNo);
};
/** ```
 * 위시리스트 조회
 *   `/customer/wishList?webCustNo={webCustNo}`
 * parameter
 * ```*/ var useWishlist = function(webCustNo, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(webCustNo)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(webCustNo)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity
    }, options));
};
/* harmony default export */ __webpack_exports__["Z"] = (useWishlist);



/***/ }),

/***/ 7682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sP": function() { return /* binding */ eventDetailAsync; }
/* harmony export */ });
/* unused harmony exports eventDetailSSR, getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _COMPONENTS_common_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23234);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87633);





var key = "useEventDetail";
/** ```
 * 행사 정보 조회
 *   `/pkg/api/event/{evCd}`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var getPath = function(evCd) {
    if (!evCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/event/").concat(evCd);
};
/** ```
 * 행사 정보 조회
 *   `/pkg/api/event/{evCd}`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var eventDetailAsync = function(evCd) {
    return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(getPath(evCd), {
        method: "GET"
    });
};
/** ```
 * 행사 정보 조회
 *   `/pkg/api/event/{evCd}`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var eventDetailSSR = function(evCd) {
    return useConfigureAxios(getPath(evCd), {
        method: "GET"
    });
};
/** ```
 * 행사 정보 조회
 *   `/pkg/api/event/{evCd}`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var useEventDetail = function(evCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                url: getPath(evCd)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60,
        placeholderData: {
            body: _COMPONENTS_common_constants__WEBPACK_IMPORTED_MODULE_0__/* .EVENT_DETAIL */ .Ny
        }
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useEventDetail);



/***/ }),

/***/ 82834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kC": function() { return /* binding */ goodsCompareAsync; }
/* harmony export */ });
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20414);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87633);






/** ```
 * 상품 비교하기
 *   `/pkg/goods/compare
 * parameter
 *   `compareGoodsCd` 상품코드 ex) "ATP1127,ATP1164"
 * ```*/ var key = "useGoodsCompare";
var getPath = function() {
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/goods/compare");
};
/** ```
 * 상품 비교하기
 *   `/pkg/goods/compare
 * parameter
 *   `compareGoodsCd` 상품코드 ex) "ATP1127,ATP1164"
 * ```*/ var goodsCompareAsync = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(compareGoodsCd) {
        var result, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(getPath(), (_tmp.method = "POST", _tmp.data = {
                            compareGoodsCd: compareGoodsCd
                        }, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function goodsCompareAsync(compareGoodsCd) {
        return _ref.apply(this, arguments);
    };
}();
/** ```
 * 상품 비교하기
 *   `/pkg/goods/compare
 * parameter
 *   `compareGoodsCd` 상품코드 ex) "ATP1127,ATP1164"
 * ```*/ var useGoodsCompare = function(compareGoodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath()
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(),
                method: "POST",
                data: {
                    compareGoodsCd: compareGoodsCd
                }
            }).then(function(r) {
                return r.data;
            });
        }
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useGoodsCompare);



/***/ }),

/***/ 85961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, goodsFilterSSR */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 상품 필터 정보
 *   `/pkg/goods/by-menu/${dspSid}/filter`
 * parameter
 * ```*/ var key = "useGoodsFilter";
var getPath = function(dspSid) {
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/goods/by-menu/").concat(dspSid, "/filter");
};
/** ```
 * 상품 필터 정보 SSR
 *   `/pkg/goods/by-menu/${dspSid}/filter`
 * parameter
 * ```*/ var goodsFilterSSR = function(dspSid) {
    return useConfigureAxios(getPath(dspSid), {
        method: "GET"
    });
};
/** ```
 * 상품 필터 정보
 *   `/prdt/api/filter/${dspSid}`
 * parameter
 * ```*/ var useGoodsFilter = function(dspSid, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(dspSid)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(dspSid)
            }).then(function(r) {
                return r.data;
            });
        }
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useGoodsFilter);



/***/ }),

/***/ 89327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ localList_m_page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./hooks/common/useOverlay.tsx + 1 modules
var useOverlay = __webpack_require__(91864);
// EXTERNAL MODULE: ./hooks/common/useScrollRestoration.tsx
var useScrollRestoration = __webpack_require__(69530);
// EXTERNAL MODULE: ./hooks/common/useTagging.ts + 5 modules
var useTagging = __webpack_require__(40070);
// EXTERNAL MODULE: ./components/common/error/ErrorBoundary.tsx + 8 modules
var ErrorBoundary = __webpack_require__(17550);
// EXTERNAL MODULE: ./components/layout/footer/Mobile/index.tsx + 1 modules
var Mobile = __webpack_require__(37875);
// EXTERNAL MODULE: ./components/layout/header/Mobile/index.tsx + 3 modules
var header_Mobile = __webpack_require__(62499);
// EXTERNAL MODULE: ./components/product/common/popup/mobile/EventListPopup/index.tsx + 9 modules
var EventListPopup = __webpack_require__(62306);
// EXTERNAL MODULE: ./components/product/pages/localList/common/GTMTags.tsx
var GTMTags = __webpack_require__(21679);
// EXTERNAL MODULE: ./components/product/pages/localList/common/filterHook.tsx
var filterHook = __webpack_require__(87061);
// EXTERNAL MODULE: ./components/style/productlist/productlistM.tsx
var productlistM = __webpack_require__(31873);
// EXTERNAL MODULE: ./framework/ui/mobile/filter/index.tsx
var filter = __webpack_require__(10696);
// EXTERNAL MODULE: ./framework/ui/mobile/input/index.ts + 5 modules
var input = __webpack_require__(48609);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/common/commonUtil.ts + 1 modules
var commonUtil = __webpack_require__(72425);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./public/P/images/ico/ico_spr.png
var ico_spr = __webpack_require__(99653);
var ico_spr_default = /*#__PURE__*/__webpack_require__.n(ico_spr);
// EXTERNAL MODULE: ./node_modules/@yb/styled-px2rem/esm/index.esm.js
var index_esm = __webpack_require__(53842);
;// CONCATENATED MODULE: ./components/style/productlist/FilterM.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-bottom: 100px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding: 25px 15px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-top: -1px;\n	border-top: 1px solid transparent;\n	border-bottom: 1px solid ",
        ";\n	",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	padding: 15px 50px 15px 15px;\n	cursor: pointer;\n\n	",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	z-index: 1;\n	display: flex;\n	align-items: center;\n	gap: 10px;\n	font-size: 17px;\n	span {\n		font-weight: bold;\n	}\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	transition: height 0.5s ease;\n	height: 0;\n	opacity: 0;\n	overflow: hidden;\n\n	",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	right: 0;\n	top: 50%;\n	padding: 0 22px 0 7px;\n	margin-top: -4px;\n	background-color: transparent;\n	transform: translateY(-50%);\n\n	&:after {\n		display: block;\n		width: 7px;\n		height: 7px;\n		border-top: 1px solid var(--emp-color);\n		border-right: 1px solid var(--emp-color);\n		font-size: 0px;\n		transform: rotate(135deg);\n		content: "";\n	}\n\n	',
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	gap: 10px;\n	padding: 20px 15px;\n	background-color: #f7f7f7;\n	border-top: 1px solid var(--line-color);\n	border-bottom: 1px solid var(--line-color);\n	select {\n		background-color: #fff;\n	}\n	> div {\n		flex: 0 0 calc(50% - 5px);\n	}\n	+ div {\n		margin: 20px 0;\n	}\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	background-color: #fff;\n	input {\n		position: relative;\n		z-index: 1;\n		background-color: transparent;\n		&::placeholder {\n			color: var(--default-color);\n		}\n	}\n	i {\n		position: absolute;\n		right: 10px;\n		top: 50%;\n		z-index: 0;\n		width: 20px;\n		height: 20px;\n		transform: translateY(-50%);\n	}\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-wrap: wrap;\n	flex: 1 1 auto;\n	gap: 5px;\n	width: 100%;\n	padding: 20px 15px;\n	background-color: #f7f7f7;\n	border-top: 1px solid var(--line-color);\n	li {\n		label {\n			padding: 10px 15px;\n		}\n		input {\n			&:checked + label {\n				display: flex;\n				align-items: center;\n				gap: 10px;\n				&::after {\n					transform: translateY(-14%) rotate(45deg);\n				}\n			}\n		}\n	}\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	input {\n		position: absolute;\n		top: 0;\n		left: 0;\n		width: 1px;\n		height: 1px;\n		padding: 0;\n		margin: 0;\n		background-color: transparent;\n		border: 0;\n\n		&:checked {\n			+ label {\n				font-weight: bold;\n				border-color: var(--emp-color);\n				color: var(--emp-color);\n				&::after {\n					display: block;\n					flex: 0 0 auto;\n					width: 6px;\n					height: 11px;\n					border-right: 0.15rem solid var(--emp-color);\n					border-bottom: 0.15rem solid var(--emp-color);\n					content: "";\n				}\n			}\n		}\n\n		+ label {\n			display: inline-block;\n			width: 100%;\n			padding: 9px 15px;\n			border: 1px solid var(--line-color);\n			border-radius: 8px;\n			background-color: #fff;\n			box-sizing: border-box;\n			overflow: hidden;\n		}\n	}\n	+ li {\n		margin-left: 2px;\n	}\n'
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	left: 0;\n	right: 0;\n	bottom: 0;\n	z-index: 10;\n\n	> button {\n		height: 55px;\n	}\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	height: 45px;\n	padding-left: 10px;\n	border-top: 1px solid var(--line-color);\n	background-color: #f7f7f7;\n\n	> span {\n		display: flex;\n		gap: 7px;\n		font-size: 0;\n		&:before {\n			display: inline-block;\n			width: 15px;\n			height: 15px;\n			background: url(",
        ') -222px 0 / 400px 400px;\n			content: "";\n		}\n	}\n	> button {\n		flex: 0 0 auto;\n		padding-right: 10px;\n		margin-right: 10px;\n		font-size: 14px;\n		color: var(--default-color);\n		border-right: 1px solid var(--line-color);\n	}\n'
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	gap: 15px;\n	overflow-x: auto;\n	height: 100%;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	align-items: center;\n	flex: 0 0 auto;\n	font-size: 14px;\n\n	button {\n		position: relative;\n		width: 10px;\n		height: 10px;\n		background-color: transparent;\n\n		&::before,\n		&::after {\n			position: absolute;\n			top: 0;\n			right: 0px;\n			display: block;\n			width: 1px;\n			height: 12px;\n			background-color: var(--emp-color);\n			content: "";\n		}\n		&::before {\n			transform: rotate(45deg);\n		}\n		&::after {\n			transform: rotate(-45deg);\n		}\n	}\n	&:last-child {\n		padding-right: 10px;\n	}\n'
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}


var Wrap = index_esm/* default.div */.ZP.div(_templateObject());
var ContentWrap = index_esm/* default.div */.ZP.div(_templateObject1());
var AccordionArea = index_esm/* default.ul */.ZP.ul(_templateObject2(), function(props) {
    return props.border && "border-top: 1px solid var(--line-color);";
});
var AccordionItem = index_esm/* default.li */.ZP.li(_templateObject3(), function(props) {
    return props.isToggle ? "var(--emp-color)" : "var(--line-color)";
}, function(props) {
    return props.isToggle && "\n				border-top: 1px solid var(--emp-color);\n			";
});
var AccordionContent = index_esm/* default.div */.ZP.div(_templateObject4(), function(props) {
    return props.isToggle && "\n		h5 {\n			font-weight: bold;\n		}\n	";
});
var AccordionTitle = index_esm/* default.h5 */.ZP.h5(_templateObject5());
var AccordionDetail = index_esm/* default.div */.ZP.div(_templateObject6(), function(props) {
    return props.isActive && "\n			opacity: 1;\n			height: auto;\n	";
});
var AccordionMoreButton = index_esm/* default.button */.ZP.button(_templateObject7(), function(props) {
    return props.isToggle && "\n		top: calc(50% + 5px);\n		&:after {\n			transform: rotate(-45deg);\n		}\n    ";
});
var InputWrap = index_esm/* default.div */.ZP.div(_templateObject8());
var CalendarInput = index_esm/* default.div */.ZP.div(_templateObject9());
var CheckList = index_esm/* default.ul */.ZP.ul(_templateObject10());
var CheckListItem = index_esm/* default.li */.ZP.li(_templateObject11());
var FloatArea = index_esm/* default.div */.ZP.div(_templateObject12());
var FilterTagBox = index_esm/* default.div */.ZP.div(_templateObject13(), (ico_spr_default()));
var TagList = index_esm/* default.ul */.ZP.ul(_templateObject14());
var TagListItem = index_esm/* default.li */.ZP.li(_templateObject15());


// EXTERNAL MODULE: ./framework/ui/mobile/button/index.tsx + 8 modules
var mobile_button = __webpack_require__(28426);
// EXTERNAL MODULE: ./framework/ui/mobile/layout/index.tsx + 2 modules
var layout = __webpack_require__(48418);
// EXTERNAL MODULE: ./framework/ui/mobile/popup/index.ts + 3 modules
var popup = __webpack_require__(62835);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/goods/useGoodsFilter.ts
var useGoodsFilter = __webpack_require__(85961);
// EXTERNAL MODULE: ./node_modules/@yb/utils/dist/ybutil.cjs.js
var ybutil_cjs = __webpack_require__(20279);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/product/pages/localList/mobile/filter/detailFilter/DepartureAirport.tsx




var DepartureAirportComponent = function(param) {
    var tagList = param.tagList, handleTagCheck = param.handleTagCheck, dataStr = param.dataStr;
    var dataList = dataStr.replaceAll("|", "").split("^");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckList, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckListItem, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox",
                        id: "outCityList0",
                        onChange: function(e) {
                            return handleTagCheck(e.target.checked, e.target.value);
                        },
                        checked: !tagList.length,
                        value: "전체"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "outCityList0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "전체"
                        })
                    })
                ]
            }),
            dataList.map(function(value, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckListItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "checkbox",
                            id: "outCityList".concat(idx + 1),
                            onChange: function(e) {
                                return handleTagCheck(e.target.checked, e.target.value);
                            },
                            checked: tagList.includes(value),
                            value: value
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "outCityList".concat(idx + 1),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: value
                            })
                        })
                    ]
                }, idx);
            })
        ]
    });
};
var DepartureAirport = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailFilter DepartureAirport Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DepartureAirportComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var detailFilter_DepartureAirport = (DepartureAirport);

// EXTERNAL MODULE: ./public/M/images/ico/ico_spr.png
var ico_ico_spr = __webpack_require__(15042);
var ico_ico_spr_default = /*#__PURE__*/__webpack_require__.n(ico_ico_spr);
;// CONCATENATED MODULE: ./framework/ui/mobile/icon/SearchIcon.tsx

function SearchIcon_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				width: 16px;\n				background-position: -20px -78px;\n			"
    ]);
    SearchIcon_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchIcon_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				background-position: -40px -78px;\n			"
    ]);
    SearchIcon_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchIcon_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				background-position: 0px -78px;\n			"
    ]);
    SearchIcon_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SearchIcon_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				width: 21px;\n				height: 21px;\n				margin-left: 5px;\n				background-position: 0px -16px;\n				background-size: 300px 300px;\n			"
    ]);
    SearchIcon_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SearchIcon_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: block;\n	width: 20px;\n	height: 20px;\n	background-image: url(",
        ");\n	background-size: 300px 300px;\n\n	",
        "\n"
    ]);
    SearchIcon_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var SearchIcon = index_esm/* default.i */.ZP.i(SearchIcon_templateObject4(), (ico_ico_spr_default()), function(props) {
    if (props.icon === "calendar") {
        return (0,index_esm/* css */.iv)(SearchIcon_templateObject());
    }
    if (props.icon === "member") {
        return (0,index_esm/* css */.iv)(SearchIcon_templateObject1());
    }
    if (props.icon === "map") {
        return (0,index_esm/* css */.iv)(SearchIcon_templateObject2());
    }
    if (props.icon === "search") {
        return (0,index_esm/* css */.iv)(SearchIcon_templateObject3());
    }
});
/* harmony default export */ var icon_SearchIcon = (SearchIcon);

// EXTERNAL MODULE: ./framework/ui/mobile/select/index.ts + 1 modules
var mobile_select = __webpack_require__(78093);
// EXTERNAL MODULE: ./components/hoc/withCalendar.tsx
var withCalendar = __webpack_require__(25893);
// EXTERNAL MODULE: ./hooks/services/queries/essential/contents/useContentsHoliday.ts
var useContentsHoliday = __webpack_require__(6843);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
;// CONCATENATED MODULE: ./components/product/pages/localList/mobile/filter/LocalFilterCalendar.tsx

function LocalFilterCalendar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				width: 100%;\n				margin: 0 auto;\n			"
    ]);
    LocalFilterCalendar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LocalFilterCalendar_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				width: 100%;\n				margin: 0 auto;\n			"
    ]);
    LocalFilterCalendar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LocalFilterCalendar_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        "\n"
    ]);
    LocalFilterCalendar_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function LocalFilterCalendar_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			table {\n				th {\n					height: 22px;\n					background-color: #fff;\n					text-align: center;\n					&:not(:last-child),\n					&:last-child {\n						border: none;\n					}\n				}\n				td {\n					height: 22px;\n					padding: 0;\n					&:not(:last-child),\n					&:last-child {\n						border: none;\n					}\n				}\n			}\n		"
    ]);
    LocalFilterCalendar_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function LocalFilterCalendar_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			table {\n				th {\n					height: 50px;\n					background-color: #fff;\n					text-align: center;\n					border-top: 0;\n				}\n				td {\n					position: relative;\n					height: 50px;\n					padding: 0;\n					border: 1px solid var(--line-color);\n					border-collapse: collapse;\n\n					&:first-child {\n						color: var(--red-color);\n					}\n					&:last-child {\n						color: var(--blue-color);\n					}\n\n					span {\n						position: relative;\n						display: inline-flex;\n						align-items: flex-start;\n						padding-top: 10px;\n						font-size: 12px;\n					}\n				}\n			}\n		"
    ]);
    LocalFilterCalendar_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function LocalFilterCalendar_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 100%;\n	background-color: #fff;\n	",
        "\n	",
        "\n"
    ]);
    LocalFilterCalendar_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function LocalFilterCalendar_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	display: flex;\n	width: 100%;\n	justify-content: center;\n	em {\n		font-size: 22px;\n		font-weight: bold;\n		color: var(--emp-color);\n		line-height: 1;\n	}\n	label {\n		font-size: var(--medium-size);\n		font-weight: normal;\n	}\n	ul {\n		top: 50px;\n		left: 50%;\n		width: 100%;\n		max-height: 155px;\n		transform: translateX(-50%);\n		> li {\n			justify-content: center;\n			padding: 0;\n		}\n	}\n	> div {\n		width: auto;\n	}\n"
    ]);
    LocalFilterCalendar_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function LocalFilterCalendar_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: 13px;\n	width: 12px;\n	height: 12px;\n	border-left: 1px solid var(--emp-color);\n	border-bottom: 1px solid var(--emp-color);\n	background-color: transparent;\n\n	&:disabled {\n		border-color: var(--bl-color);\n	}\n\n	",
        "\n"
    ]);
    LocalFilterCalendar_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function LocalFilterCalendar_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 100%;\n	border-bottom: 1px solid var(--line-color);\n	table-layout: fixed;\n"
    ]);
    LocalFilterCalendar_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function LocalFilterCalendar_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				font-size: 12px;\n			"
    ]);
    LocalFilterCalendar_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function LocalFilterCalendar_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	height: 22px;\n	padding: 10px;\n	box-sizing: border-box;\n	border-top: 1px solid var(--line-color);\n	font-size: 12px;\n	color: var(--emp-color);\n	text-align: center;\n	&:first-child {\n		color: #ff5c46;\n	}\n	&:last-child {\n		color: #4567ad;\n	}\n	",
        "\n"
    ]);
    LocalFilterCalendar_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function LocalFilterCalendar_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				&:first-child {\n					> span {\n						color: ",
        ";\n					}\n				}\n				&:last-child {\n					> span {\n						color: ",
        ";\n					}\n				}\n				> span {\n					font-size: 12px;\n					color: #aaa;\n				}\n			"
    ]);
    LocalFilterCalendar_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function LocalFilterCalendar_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					border: none;\n					> span {\n						border-color: var(--emp-color);\n					}\n				"
    ]);
    LocalFilterCalendar_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function LocalFilterCalendar_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n				",
        ";\n				> span::after {\n					display: block;\n					top: 16px;\n				}\n			"
    ]);
    LocalFilterCalendar_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function LocalFilterCalendar_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					background-color: var(--yellow-color);\n					color: var(--emp-color);\n				"
    ]);
    LocalFilterCalendar_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function LocalFilterCalendar_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					background-color: var(--line-color);\n					color: var(--emp-color);\n				"
    ]);
    LocalFilterCalendar_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					background-color: #a4bdf0;\n					color: var(--emp-color);\n				"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	box-sizing: border-box;\n	height: 22px;\n	color: ",
        ";\n	vertical-align: top;\n	text-align: left;\n	cursor: ",
        ";\n\n	",
        "\n	> span {\n		border: 1px solid transparent;\n		border-color: ",
        ";\n		box-sizing: border-box;\n		",
        "\n	}\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n			color: #fff;\n			&::after {\n				position: absolute;\n				top: 7px;\n				left: 50%;\n				z-index: -1;\n				transform: translate(-50%, -50%);\n				display: none;\n				width: 25px;\n				height: 25px;\n				border-radius: 50%;\n				background-color: var(--emp-color);\n				content: "";\n			}\n		'
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: center;\n	width: 100%;\n	height: 100%;\n	z-index: 1;\n	color: ",
        ";\n	",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}






var CalendarWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c53968c8-0"
})(LocalFilterCalendar_templateObject2(), function(props) {
    if (props.types === "basic") {
        return (0,styled_components_browser_esm.css)(LocalFilterCalendar_templateObject());
    }
    if (props.types === "schedule") {
        return (0,styled_components_browser_esm.css)(LocalFilterCalendar_templateObject1());
    }
});
var CalendarBox = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c53968c8-1"
})(LocalFilterCalendar_templateObject5(), function(props) {
    return props.types === "basic" && (0,styled_components_browser_esm.css)(LocalFilterCalendar_templateObject3());
}, function(props) {
    return props.types === "schedule" && (0,styled_components_browser_esm.css)(LocalFilterCalendar_templateObject4());
});
var CalendarMonth = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c53968c8-2"
})(LocalFilterCalendar_templateObject6());
var MonthButton = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-c53968c8-3"
})(LocalFilterCalendar_templateObject7(), function(props) {
    return props.types === "prev" ? "\n                left: 20%;\n                transform: rotate(45deg);\n            " : "\n                right: 20%;\n                transform: rotate(-135deg);\n            ";
});
var TableCalendar = styled_components_browser_esm["default"].table.withConfig({
    componentId: "sc-c53968c8-4"
})(LocalFilterCalendar_templateObject8());
var Month = styled_components_browser_esm["default"].th.withConfig({
    componentId: "sc-c53968c8-5"
})(LocalFilterCalendar_templateObject10(), function(props) {
    if (props.types === "basic") {
        return (0,styled_components_browser_esm.css)(LocalFilterCalendar_templateObject9());
    }
});
var ProductDays = styled_components_browser_esm["default"].td.withConfig({
    componentId: "sc-c53968c8-6"
})(_templateObject17(), function(props) {
    return props.isActive ? "var(--emp-color)" : "#aaa";
}, function(props) {
    return props.isActive ? "pointer" : "initial";
}, function(props) {
    if (props.types === "basic") {
        return (0,styled_components_browser_esm.css)(LocalFilterCalendar_templateObject11(), props.rev ? "var(--emp-color)" : "var(--red-color)", props.rev ? "var(--emp-color)" : "var(--blue-color)");
    }
    if (props.types === "schedule") {
        return (0,styled_components_browser_esm.css)(LocalFilterCalendar_templateObject13(), props.CheckedDay && (0,styled_components_browser_esm.css)(LocalFilterCalendar_templateObject12()));
    }
}, function(props) {
    return props.CheckedDay ? "var(--emp-color)" : "transparent";
}, function(props) {
    if (props.rev === "can" && props.types === "basic") {
        return (0,styled_components_browser_esm.css)(LocalFilterCalendar_templateObject14());
    }
    if (props.rev === "end" && props.types === "basic") {
        return (0,styled_components_browser_esm.css)(LocalFilterCalendar_templateObject15());
    }
    if (props.rev === "wait" && props.types === "basic") {
        return (0,styled_components_browser_esm.css)(_templateObject16());
    }
});
var Day = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-c53968c8-7"
})(_templateObject19(), function(props) {
    return props.holiday ? "var(--red-color)" : "";
}, function(props) {
    return props.today && (0,styled_components_browser_esm.css)(_templateObject18());
});
var LocalFilterCalendar = (0,withCalendar/* default */.Z)(function(props) {
    var ref;
    var types = "schedule";
    var today = dayjs_min_default()();
    var date = props.date, isNext = props.isNext, isPrevious = props.isPrevious, rangeMonth = props.rangeMonth, dayList = props.dayList, month = props.month, dateChange = props.dateChange, monthChange = props.monthChange, nextMonth = props.nextMonth, prevMonth = props.prevMonth, handleClose = props.data.handleClose;
    var holidayFetch = (0,useContentsHoliday/* default */.ZP)(dayjs_min_default()(month).format("YYYY"), {
        staleTime: 1000 * 60 * 5
    });
    var ref1;
    var holiday = (ref1 = (ref = holidayFetch.data) === null || ref === void 0 ? void 0 : ref.body) !== null && ref1 !== void 0 ? ref1 : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarWrap, {
        types: types,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CalendarBox, {
            types: types,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CalendarMonth, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_select/* Select */.P, {
                            types: "calendar",
                            width: "auto",
                            onChange: function(e) {
                                return monthChange(e.target.value);
                            },
                            value: month.format("YYYYMMDD"),
                            children: rangeMonth === null || rangeMonth === void 0 ? void 0 : rangeMonth.map(function(day, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: day.format("YYYYMMDD"),
                                    children: day.format("YYYY.MM")
                                }, index);
                            })
                        }),
                        isPrevious && /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthButton, {
                            types: "prev",
                            onClick: prevMonth,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "이전달"
                            })
                        }),
                        isNext && /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthButton, {
                            types: "next",
                            onClick: nextMonth,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "다음달"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCalendar, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                        types: types,
                                        children: "일"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                        types: types,
                                        children: "월"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                        types: types,
                                        children: "화"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                        types: types,
                                        children: "수"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                        types: types,
                                        children: "목"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                        types: types,
                                        children: "금"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                        types: types,
                                        children: "토"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                            children: dayList === null || dayList === void 0 ? void 0 : dayList.map(function(week, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("tr", {
                                    children: week.map(function(day, weekIdx) {
                                        var dayFormat = day === null || day === void 0 ? void 0 : day.format("YYYYMMDD");
                                        var isHoliday = !!holiday.find(function(v) {
                                            return v.calDt === dayFormat;
                                        });
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDays, {
                                            types: types,
                                            isActive: !(day < today.add(-1, "day")),
                                            onClick: function() {
                                                if (!(day < today.add(-1, "day"))) {
                                                    dateChange(day);
                                                    handleClose();
                                                }
                                            },
                                            CheckedDay: date && date.isSame(day),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Day, {
                                                today: day && today.isSame(day, "day"),
                                                holiday: isHoliday,
                                                children: day && day.format("DD")
                                            })
                                        }, weekIdx);
                                    })
                                }, index);
                            })
                        })
                    ]
                })
            ]
        })
    });
});
/* harmony default export */ var filter_LocalFilterCalendar = (LocalFilterCalendar);

;// CONCATENATED MODULE: ./components/product/pages/localList/mobile/filter/detailFilter/DepartureDate.tsx











var getMonthStr = function(str) {
    return "".concat(str.substring(0, 4), "년").concat(str.substring(4, 6), "월");
};
var DepartureDateComponent = function(param) {
    var dataStr = param.dataStr, handleMonth = param.handleMonth, outStartDate = param.outStartDate, removeOutStartDate = param.removeOutStartDate, handleCalendar = param.handleCalendar;
    var ref;
    var monList = dataStr.replaceAll("|", "").split("^");
    var ref1 = (0,react.useState)(), minDate = ref1[0], setMinDate = ref1[1];
    var ref2 = (0,react.useState)(), maxDate = ref2[0], setMaxDate = ref2[1];
    var ref3 = (0,react.useState)(false), showCalendar = ref3[0], setShowCalendar = ref3[1];
    var onCalendarClick = function() {
        setShowCalendar(!showCalendar);
    };
    // 달력, 기본값 초기화
    (0,react.useEffect)(function() {
        if (monList) {
            var ref = [
                monList[0],
                monList[monList.length - 1]
            ], firstMon = ref[0], lastMon = ref[1];
            setMinDate(firstMon);
            setMaxDate(lastMon);
        }
    }, [
        monList,
        outStartDate.value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(mobile_select/* Select */.P, {
                        onChange: function(e) {
                            return handleMonth(e.target.value);
                        },
                        value: outStartDate.value,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: FILTER_ALL,
                                children: "출발 월 전체"
                            }),
                            monList.map(function(month, idx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: month,
                                    children: getMonthStr(month)
                                }, idx);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CalendarInput, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* TextInput */.oi, {
                                readOnly: true,
                                placeholder: "출발일 선택",
                                value: ((ref = outStartDate.value) === null || ref === void 0 ? void 0 : ref.length) === 8 ? dayjs_min_default()(outStartDate.value).format("YYYY.MM.DD") : "",
                                onClick: onCalendarClick
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_SearchIcon, {
                                icon: "calendar"
                            })
                        ]
                    })
                ]
            }),
            showCalendar && /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_LocalFilterCalendar, {
                minDate: minDate,
                maxDate: maxDate,
                value: outStartDate.value,
                onDateChange: function(date) {
                    if (date === null) {
                        removeOutStartDate();
                        return;
                    }
                    var thisDate = date ? date.format("YYYYMMDD") : "";
                    handleCalendar(thisDate);
                },
                data: {
                    handleClose: function() {
                        return setShowCalendar(false);
                    }
                }
            })
        ]
    });
};
var DepartureDate = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailFilter DeparetureDate Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DepartureDateComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var detailFilter_DepartureDate = (DepartureDate);

;// CONCATENATED MODULE: ./components/product/pages/localList/mobile/filter/detailFilter/DepartureDay.tsx




var DepartureDayComponent = function(param) {
    var tagList = param.tagList, handleTagCheck = param.handleTagCheck, dataStr = param.dataStr;
    var dataList = dataStr.replaceAll("|", "").split("^");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckList, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckListItem, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox",
                        id: "wdayList0",
                        onChange: function(e) {
                            return handleTagCheck(e.target.checked, e.target.value);
                        },
                        checked: !tagList.length,
                        value: "전체"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "wdayList0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "전체"
                        })
                    })
                ]
            }),
            dataList.map(function(value, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckListItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "checkbox",
                            id: "wdayList".concat(idx + 1),
                            onChange: function(e) {
                                return handleTagCheck(e.target.checked, e.target.value);
                            },
                            checked: tagList.includes(value),
                            value: value
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "wdayList".concat(idx + 1),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: value
                            })
                        })
                    ]
                }, idx);
            })
        ]
    });
};
var DepartureDay = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailFilter DepartureDay Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DepartureDayComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var detailFilter_DepartureDay = (DepartureDay);

;// CONCATENATED MODULE: ./components/product/pages/localList/mobile/filter/detailFilter/DepartureTime.tsx




var DepartureTimeComponent = function(param) {
    var tagList = param.tagList, handleTagCheck = param.handleTagCheck, dataStr = param.dataStr;
    var dataList = dataStr.replaceAll("|", "").split("^");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckList, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckListItem, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox",
                        id: "outDeprtFgList0",
                        onChange: function(e) {
                            return handleTagCheck(e.target.checked, e.target.value);
                        },
                        checked: !tagList.length,
                        value: "전체"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "outDeprtFgList0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "전체"
                        })
                    })
                ]
            }),
            dataList.map(function(value, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckListItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "checkbox",
                            id: "outDeprtFgList".concat(idx + 1),
                            onChange: function(e) {
                                return handleTagCheck(e.target.checked, e.target.value);
                            },
                            checked: tagList.includes(value),
                            value: value
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "outDeprtFgList".concat(idx + 1),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: value
                            })
                        })
                    ]
                }, idx);
            })
        ]
    });
};
var DepartureTime = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailFilter DepartureTime Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DepartureTimeComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var detailFilter_DepartureTime = (DepartureTime);

;// CONCATENATED MODULE: ./components/product/pages/localList/mobile/filter/detailFilter/ProductFeature.tsx





var ProductFeatureComponent = function(param) {
    var tagList = param.tagList, handleTagCheck = param.handleTagCheck, dataStr = param.dataStr;
    var featuresListData = dataStr.replaceAll("|", "").split("^");
    var featuresList = [];
    for(var i = 0; i < featuresListData.length; i += 3){
        var code = featuresListData[i];
        var name = featuresListData[i + 1];
        var divi = featuresListData[i + 2];
        featuresList.push({
            code: code,
            name: name,
            divi: divi
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckList, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckListItem, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox",
                        id: "features-PC00",
                        onChange: function(e) {
                            return handleTagCheck(e.target.checked, e.target.value);
                        },
                        checked: !tagList.length,
                        value: FILTER_ALL
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "features-PC00",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "전체"
                        })
                    })
                ]
            }),
            featuresList.map(function(feature, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckListItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "checkbox",
                            id: "features".concat(feature.code),
                            onChange: function(e) {
                                return handleTagCheck(e.target.checked, e.target.value);
                            },
                            checked: tagList.some(function(e) {
                                return e.code === feature.code;
                            }),
                            value: JSON.stringify((0,_object_spread/* default */.Z)({}, feature))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "features".concat(feature.code),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: feature.name
                            })
                        })
                    ]
                }, idx);
            })
        ]
    });
};
var ProductFeature = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailFilter ProductFeature Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductFeatureComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var detailFilter_ProductFeature = (ProductFeature);

;// CONCATENATED MODULE: ./components/product/pages/localList/mobile/filter/detailFilter/Promotion.tsx





var PromotionComponent = function(param) {
    var tagList = param.tagList, handleTagCheck = param.handleTagCheck, dataStr = param.dataStr;
    var promotionListData = dataStr.replaceAll("|", "").split("^");
    var promotionList = [];
    for(var i = 0; i < promotionListData.length; i += 2){
        var code = promotionListData[i];
        var name = promotionListData[i + 1];
        promotionList.push({
            code: code,
            name: name
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckList, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckListItem, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox",
                        id: "promotionALL",
                        onChange: function(e) {
                            return handleTagCheck(e.target.checked, e.target.value);
                        },
                        checked: !tagList.length,
                        value: JSON.stringify({
                            code: FILTER_ALL,
                            name: "전체"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "promotionALL",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "전체"
                        })
                    })
                ]
            }),
            promotionList.map(function(promotion, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckListItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "checkbox",
                            id: "promotion".concat(promotion.code),
                            onChange: function(e) {
                                return handleTagCheck(e.target.checked, e.target.value);
                            },
                            checked: tagList.some(function(e) {
                                return e.code === promotion.code;
                            }),
                            value: JSON.stringify((0,_object_spread/* default */.Z)({}, promotion))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "promotion".concat(promotion.code),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: promotion.name
                            })
                        })
                    ]
                }, idx);
            })
        ]
    });
};
var Promotion = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailFilter Promotion Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var detailFilter_Promotion = (Promotion);

;// CONCATENATED MODULE: ./components/product/pages/localList/mobile/filter/detailFilter/Transportation.tsx




var TransportationComponent = function(param) {
    var tagList = param.tagList, handleTagCheck = param.handleTagCheck, dataStr = param.dataStr;
    var airListData = (dataStr === null || dataStr === void 0 ? void 0 : dataStr.replaceAll("|", "").split("^")) || [];
    var airList = [];
    for(var i = 0; i < airListData.length; i += 2){
        var code = airListData[i];
        var name = airListData[i + 1];
        airList.push({
            code: code,
            name: name
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckList, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckListItem, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox",
                        id: "airline-ALL",
                        onChange: function(e) {
                            return handleTagCheck(e.target.checked, e.target.value);
                        },
                        checked: !tagList.length,
                        value: JSON.stringify({
                            code: "ALL",
                            name: "전체"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "airline-ALL",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "전체"
                        })
                    })
                ]
            }),
            airList.map(function(air, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckListItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "checkbox",
                            id: "airline-".concat(air.code),
                            onChange: function(e) {
                                return handleTagCheck(e.target.checked, e.target.value);
                            },
                            checked: tagList.some(function(e) {
                                return e.code === air.code;
                            }),
                            value: JSON.stringify((0,_object_spread/* default */.Z)({}, air))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "airline-".concat(air.code),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: air.name
                            })
                        })
                    ]
                }, idx);
            })
        ]
    });
};
var Transportation = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailFilter Transportation Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransportationComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var detailFilter_Transportation = (Transportation);

;// CONCATENATED MODULE: ./components/product/pages/localList/mobile/filter/detailFilter/TravelBudget.tsx








var TravelBudgetComponent = function(param) {
    var initialPrice = param.initialPrice, minPricePlaceholder = param.minPricePlaceholder, maxPricePlaceholder = param.maxPricePlaceholder, handlePriceText = param.handlePriceText;
    var ref = (0,react.useState)(initialPrice), price = ref[0], setPrice = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputWrap, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* TextInput */.oi, {
                type: "number",
                placeholder: "₩".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(minPricePlaceholder)),
                onChange: function(e) {
                    return setPrice(function(prev) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                            minPrice: e.target.value
                        });
                    });
                },
                value: price.minPrice,
                onBlur: function() {
                    if (!price.minPrice) return;
                    handlePriceText(price.minPrice, price.maxPrice ? price.maxPrice : maxPricePlaceholder);
                }
            }),
            "~",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* TextInput */.oi, {
                type: "number",
                placeholder: "₩".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(maxPricePlaceholder)),
                onChange: function(e) {
                    return setPrice(function(prev) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                            maxPrice: e.target.value
                        });
                    });
                },
                value: price.maxPrice,
                onBlur: function() {
                    if (!price.maxPrice) return;
                    handlePriceText(price.minPrice ? price.minPrice : minPricePlaceholder, price.maxPrice);
                }
            })
        ]
    });
};
var TravelBudget = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailFilter TravelBudget Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelBudgetComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var detailFilter_TravelBudget = (TravelBudget);

;// CONCATENATED MODULE: ./components/product/pages/localList/mobile/filter/detailFilter/TravelDays.tsx




var TravelDaysComponent = function(param) {
    var tagList = param.tagList, handleTagCheck = param.handleTagCheck, dataStr = param.dataStr;
    var evNightListData = dataStr.replaceAll("|", "").split("^");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckList, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckListItem, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox",
                        id: "evNightList0",
                        onChange: function(e) {
                            return handleTagCheck(e.target.checked, e.target.value);
                        },
                        checked: !tagList.length,
                        value: "전체"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "evNightList0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "전체"
                        })
                    })
                ]
            }),
            evNightListData.map(function(value, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckListItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "checkbox",
                            id: "evNightList".concat(idx + 1),
                            onChange: function(e) {
                                return handleTagCheck(e.target.checked, e.target.value);
                            },
                            checked: tagList.includes(value),
                            value: value
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "evNightList".concat(idx + 1),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: value
                            })
                        })
                    ]
                }, idx);
            })
        ]
    });
};
var TravelDays = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailFilter TravelDays Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelDaysComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var detailFilter_TravelDays = (TravelDays);

;// CONCATENATED MODULE: ./components/product/pages/localList/mobile/filter/detailFilter/TravelMember.tsx





var TravelMemberComponent = function(param) {
    var tagList = param.tagList, handleTagCheck = param.handleTagCheck, dataStr = param.dataStr;
    var tmemberListData = dataStr.replaceAll("|", "").split("^");
    var tmemberList = [];
    for(var i = 0; i < tmemberListData.length; i += 2){
        var code = tmemberListData[i];
        var name = tmemberListData[i + 1];
        tmemberList.push({
            code: code,
            name: name
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckList, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckListItem, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox",
                        id: "tmemberListAll",
                        onChange: function(e) {
                            return handleTagCheck(e.target.checked, e.target.value);
                        },
                        checked: !tagList.length,
                        value: JSON.stringify({
                            code: FILTER_ALL,
                            name: "전체"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "tmemberListAll",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "전체"
                        })
                    })
                ]
            }),
            tmemberList.map(function(tmember, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckListItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "checkbox",
                            id: "tmemberList".concat(tmember.code),
                            onChange: function(e) {
                                return handleTagCheck(e.target.checked, e.target.value);
                            },
                            checked: tagList.some(function(e) {
                                return e.code === tmember.code;
                            }),
                            value: JSON.stringify((0,_object_spread/* default */.Z)({}, tmember))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "tmemberList".concat(tmember.code),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: tmember.name
                            })
                        })
                    ]
                }, idx);
            })
        ]
    });
};
var TravelMember = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailFilter TravelMember Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelMemberComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var detailFilter_TravelMember = (TravelMember);

;// CONCATENATED MODULE: ./components/product/pages/localList/mobile/filter/detailFilter/index.tsx




























// Array filter 관련
var FILTER_ALL = "ALL";
var getInitialFilters = function(filters) {
    var ref;
    var outStartDate = (ref = filters.filter(function(e) {
        return e.key === "outStartDateList";
    }).map(function(t) {
        return {
            value: t.value,
            text: t.text
        };
    })[0]) !== null && ref !== void 0 ? ref : {
        value: "",
        text: ""
    };
    var ref1;
    var weekDayList = (ref1 = filters.filter(function(e) {
        return e.key === "wdayList";
    }).map(function(t) {
        return t.value;
    })) !== null && ref1 !== void 0 ? ref1 : [];
    var ref2;
    var timeList = (ref2 = filters.filter(function(e) {
        return e.key === "outDeprtFgList";
    }).map(function(t) {
        return t.value;
    })) !== null && ref2 !== void 0 ? ref2 : [];
    var ref3;
    var airportList = (ref3 = filters.filter(function(e) {
        return e.key === "outCityDiviNm";
    }).map(function(t) {
        return t.value;
    })) !== null && ref3 !== void 0 ? ref3 : [];
    var ref4;
    var travelDays = (ref4 = filters.filter(function(e) {
        return e.key === "evDayCntList";
    }).map(function(t) {
        return t.text;
    })) !== null && ref4 !== void 0 ? ref4 : [];
    var ref5;
    var minMaxPriceValue = (ref5 = filters.filter(function(e) {
        return e.key === "minPrice" || e.key === "maxPrice";
    }).map(function(o) {
        return o.value;
    }).join(",")) !== null && ref5 !== void 0 ? ref5 : "";
    var ref6;
    var minMaxPriceText = (ref6 = filters.filter(function(e) {
        return e.key === "minPrice" || e.key === "maxPrice";
    }).map(function(t) {
        return "₩".concat(t.text);
    }).join(" ~ ")) !== null && ref6 !== void 0 ? ref6 : "";
    var ref7;
    var transportation = (ref7 = filters.filter(function(e) {
        return e.key === "airCd";
    }).map(function(t) {
        return {
            code: t.value,
            name: t.text
        };
    })) !== null && ref7 !== void 0 ? ref7 : [];
    var ref8;
    var productFeature = (ref8 = filters.filter(function(e) {
        return e.key === "goodsFeaturesList";
    }).map(function(t) {
        return {
            code: t.value,
            name: t.text,
            divi: ""
        };
    })) !== null && ref8 !== void 0 ? ref8 : [];
    var ref9;
    var promotion = (ref9 = filters.filter(function(e) {
        return e.key === "goodsPromotion";
    }).map(function(t) {
        return {
            code: t.value,
            name: t.text
        };
    })) !== null && ref9 !== void 0 ? ref9 : [];
    var ref10;
    var travelMember = (ref10 = filters.filter(function(e) {
        return e.key === "goodsTmember";
    }).map(function(t) {
        return {
            code: t.value,
            name: t.text
        };
    })) !== null && ref10 !== void 0 ? ref10 : [];
    return {
        outStartDate: outStartDate,
        weekDayList: weekDayList,
        timeList: timeList,
        airportList: airportList,
        travelDays: travelDays,
        minMaxPrice: {
            value: minMaxPriceValue,
            text: minMaxPriceText
        },
        transportation: transportation,
        productFeature: productFeature,
        promotion: promotion,
        travelMember: travelMember
    };
};
var getBlankFilters = function() {
    return {
        outStartDate: {
            value: "",
            text: ""
        },
        weekDayList: [],
        timeList: [],
        airportList: [],
        travelDays: [],
        minMaxPrice: {
            value: "",
            text: ""
        },
        transportation: [],
        productFeature: [],
        promotion: [],
        travelMember: []
    };
};
var OBJECT_ARRAY_FILTER_LIST = [
    "transportation",
    "productFeature",
    "promotion",
    "travelMember"
];
var setArrayFilter = function(checked, value, stateName, setState) {
    var val = value;
    if (OBJECT_ARRAY_FILTER_LIST.includes(stateName)) {
        val = JSON.parse(value);
    }
    if (checked) {
        // 사용자가 "전체"를 골랐을 경우, default로 설정
        if (val === "전체" || typeof val === "object" && val.code === FILTER_ALL) {
            return setState(function(prev) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, stateName, []));
            });
        }
        setState(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, stateName, (0,_to_consumable_array/* default */.Z)(prev[stateName]).concat([
                val
            ])));
        });
    } else {
        // Object Array를 삭제할 경우
        if (typeof val === "object") {
            return setState(function(prev) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, stateName, prev[stateName].filter(function(el) {
                    return el.code !== val.code;
                })));
            });
        }
        // String Array를 삭제할경우
        setState(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, stateName, prev[stateName].filter(function(el) {
                return el !== val;
            })));
        });
    }
};
// String filter 관련
var setObjectFilter = function(value, text, stateName, setState) {
    setState(function(prev) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, stateName, {
            value: value,
            text: text
        }));
    });
};
var LocalDetailFilterComponent = function(overlayProps) {
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,filterHook/* default */.Z)(), getFilter = ref3.getFilter, setFilter = ref3.setFilter;
    var ref4 = (0,useGoodsFilter/* default */.ZP)(router.query.dspSid), filterData = ref4.data;
    var filter = filterData.body;
    var ref5 = (0,react.useState)(0), activeIndex = ref5[0], setActiveIndex = ref5[1];
    var toggleAccordion = function(index) {
        if (activeIndex === index) {
            setActiveIndex(null);
        } else {
            setActiveIndex(index);
        }
    };
    var filters = getFilter() || [];
    var ref6;
    var ref7 = (0,react.useState)({
        goodsNm: (ref6 = (ref = filters.find(function(e) {
            return e.key === "goodsNm";
        })) === null || ref === void 0 ? void 0 : ref.value) !== null && ref6 !== void 0 ? ref6 : ""
    }), searchGoods = ref7[0], setSearchGoods = ref7[1];
    var ref8, ref9;
    var ref10 = (0,react.useState)({
        minPrice: (ref8 = (ref1 = filters.find(function(e) {
            return e.key === "minPrice";
        })) === null || ref1 === void 0 ? void 0 : ref1.value) !== null && ref8 !== void 0 ? ref8 : "",
        maxPrice: (ref9 = (ref2 = filters.find(function(e) {
            return e.key === "maxPrice";
        })) === null || ref2 === void 0 ? void 0 : ref2.value) !== null && ref9 !== void 0 ? ref9 : ""
    }), price = ref10[0], setPrice = ref10[1];
    var ref11 = (0,react.useState)(getInitialFilters(filters)), filterValues = ref11[0], setFilterValues = ref11[1];
    var reassignedFilters = (0,react.useMemo)(function() {
        return Object.keys(filterValues).map(function(stateName) {
            return {
                stateName: stateName,
                state: filterValues[stateName],
                setState: function(value) {
                    return setFilterValues(function(prev) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, stateName, value));
                    });
                }
            };
        });
    }, [
        filterValues
    ]);
    var hasFilter = (0,react.useMemo)(function() {
        var checkArray = [];
        for(var key in filterValues){
            var value = filterValues[key];
            checkArray.push(Array.isArray(value) ? !!value.length : !!value.value);
        }
        return checkArray.includes(true);
    }, [
        filterValues
    ]);
    var clearFilters = function() {
        setFilterValues(getBlankFilters());
    };
    // 출발 일정 관련
    var callAlertPopup = function(callback) {
        MessageUtil.confirm("출발 일정 조건을 변경하시는 경우<br/>기존 설정하신 출발 일정은 초기화 됩니다.<br/>출발 일정 조건을 변경하시겠습니까?", callback).then(function() {
            (0,commonUtil/* appBottomScheme */.V3)(false);
        });
    };
    var handleMonthList = (0,react.useCallback)(function(value) {
        var formatted = "";
        if (value === FILTER_ALL) {
            formatted = "출발 월 전체";
        } else {
            formatted = dayjs_min_default()(value.toString()).format("YYYY년 MM월 출발");
        }
        if (filterValues.outStartDate.value.length === 8) {
            callAlertPopup(function() {
                return setObjectFilter(value, formatted, "outStartDate", setFilterValues);
            });
        } else {
            setObjectFilter(value, formatted, "outStartDate", setFilterValues);
        }
    }, [
        filterValues.outStartDate.value
    ]);
    var removeOutStartDate = function() {
        setFilterValues(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                outStartDate: {
                    value: "",
                    text: ""
                }
            });
        });
    };
    var handleCalendar = function(date) {
        var text = "".concat(dayjs_min_default()(date).format("YYYY.MM.DD"), " 출발");
        var wday = filterValues.weekDayList[0];
        if (filterValues.outStartDate.value.length === 6 || !!wday) {
            return callAlertPopup(function() {
                // 출발 요일이 선택된 상태일 경우 초기화
                setFilterValues(function(prev) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                        weekDayList: []
                    });
                });
                setFilterValues(function(prev) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                        outStartDate: {
                            value: date,
                            text: text
                        }
                    });
                });
            });
        }
        if (!date) {
            return removeOutStartDate();
        }
        setFilterValues(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                outStartDate: {
                    value: date,
                    text: text
                }
            });
        });
    };
    // 출발 요일 관련
    var handleDepartureDay = (0,react.useCallback)(function(checked, value) {
        if (filterValues.outStartDate.value.length === 8) {
            return callAlertPopup(function() {
                // 출발일정 중 상세일이 선택된 경우 초기화
                setFilterValues(function(prev) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                        outStartDate: {
                            value: "",
                            text: ""
                        }
                    });
                });
                setArrayFilter(checked, value, "weekDayList", setFilterValues);
            });
        }
        setArrayFilter(checked, value, "weekDayList", setFilterValues);
    }, [
        filterValues.outStartDate
    ]);
    // 여행 예산 관련
    var handlePriceText = function(minPrice, maxPrice) {
        var goodsMinPrice = Number(filter.minPrice);
        var goodsMaxPrice = Number(filter.maxPrice);
        var searchMinPrice = Number(minPrice);
        var searchMaxPrice = Number(maxPrice);
        var resultMinPrice = function() {
            if (searchMinPrice < goodsMinPrice) {
                return goodsMinPrice;
            } else if (searchMinPrice > goodsMaxPrice) {
                return goodsMaxPrice;
            } else {
                return searchMinPrice;
            }
        };
        var resultMaxPrice = function() {
            if (searchMaxPrice > goodsMaxPrice) {
                return goodsMaxPrice;
            } else if (searchMaxPrice < goodsMinPrice) {
                return goodsMinPrice;
            } else {
                return searchMaxPrice;
            }
        };
        setPrice({
            minPrice: resultMinPrice().toString(),
            maxPrice: resultMaxPrice().toString()
        });
        setFilterValues(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                minMaxPrice: {
                    value: "".concat(resultMinPrice(), ",").concat(resultMaxPrice()),
                    text: "₩".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(resultMinPrice()), " ~ ₩").concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(resultMaxPrice()))
                }
            });
        });
    };
    // State, filterstore Sync
    var handleSubmit = (0,react.useCallback)(function() {
        var submitFilters = [];
        // sortOrder
        submitFilters.push(getFilter().find(function(v) {
            return v.key === "sort";
        }));
        // 상세 검색
        !!searchGoods.goodsNm && submitFilters.push({
            key: "goodsNm",
            value: searchGoods.goodsNm,
            text: searchGoods.goodsNm
        });
        // 출발 일정
        !!filterValues.outStartDate.value && submitFilters.push({
            key: "outStartDateList",
            value: filterValues.outStartDate.value,
            text: filterValues.outStartDate.text
        });
        // 출발 요일
        !!filterValues.weekDayList.length && filterValues.weekDayList.forEach(function(wday) {
            return submitFilters.push({
                key: "wdayList",
                value: wday,
                text: "".concat(wday, "요일 출발")
            });
        });
        // 출발 시간
        !!filterValues.timeList.length && filterValues.timeList.forEach(function(outDeprtFg) {
            return submitFilters.push({
                key: "outDeprtFgList",
                value: outDeprtFg,
                text: "".concat(outDeprtFg, " 출발")
            });
        });
        // 출발지(공항)
        !!filterValues.airportList.length && filterValues.airportList.forEach(function(outCityDiviNm) {
            return submitFilters.push({
                key: "outCityDiviNm",
                value: outCityDiviNm,
                text: "".concat(outCityDiviNm, " 출발")
            });
        });
        // 여행 기간
        !!filterValues.travelDays.length && filterValues.travelDays.forEach(function(evDayCnt) {
            return submitFilters.push({
                key: "evDayCntList",
                value: evDayCnt.replace("일", ""),
                text: evDayCnt
            });
        });
        // 여행 예산
        var minMaxPrice = filterValues.minMaxPrice.value ? filterValues.minMaxPrice.value.split(",") : [];
        // 여행 예산(최소)
        minMaxPrice.length > 1 && submitFilters.push({
            key: "minPrice",
            value: minMaxPrice[0],
            text: "".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(minMaxPrice[0]), "원")
        });
        // 여행 예산(최대)
        minMaxPrice.length > 1 && submitFilters.push({
            key: "maxPrice",
            value: minMaxPrice[1],
            text: "".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(minMaxPrice[1]), "원")
        });
        // 이용교통
        !!filterValues.transportation.length && filterValues.transportation.forEach(function(transport) {
            return submitFilters.push({
                key: "airCd",
                value: transport.code,
                text: transport.name
            });
        });
        // 상품특징
        !!filterValues.productFeature.length && filterValues.productFeature.forEach(function(feature) {
            return submitFilters.push({
                key: "goodsFeaturesList",
                value: feature.code,
                text: feature.name
            });
        });
        // 프로모션
        !!filterValues.promotion.length && filterValues.promotion.forEach(function(promo) {
            return submitFilters.push({
                key: "goodsPromotion",
                value: promo.code,
                text: promo.name
            });
        });
        // 여행구성원
        !!filterValues.travelMember.length && filterValues.travelMember.forEach(function(member) {
            return submitFilters.push({
                key: "goodsTmember",
                value: member.code,
                text: member.name
            });
        });
        setFilter(submitFilters);
        overlayProps.close();
    }, [
        searchGoods,
        price,
        filterValues
    ]);
    var getFilterList = function() {
        var filterComponents = [
            {
                title: "출발일정",
                Component: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(detailFilter_DepartureDate, {
                        dataStr: filter.monList,
                        handleMonth: handleMonthList,
                        outStartDate: filterValues.outStartDate,
                        removeOutStartDate: removeOutStartDate,
                        handleCalendar: handleCalendar
                    });
                }
            },
            {
                title: "출발 요일",
                Component: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(detailFilter_DepartureDay, {
                        tagList: filterValues.weekDayList,
                        handleTagCheck: handleDepartureDay,
                        dataStr: filter.wdayList
                    });
                }
            },
            {
                title: "출발 시간",
                Component: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(detailFilter_DepartureTime, {
                        tagList: filterValues.timeList,
                        handleTagCheck: function(checked, value) {
                            return setArrayFilter(checked, value, "timeList", setFilterValues);
                        },
                        dataStr: filter.outDeprtFgList
                    });
                }
            },
            {
                title: "출발지 (공항)",
                Component: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(detailFilter_DepartureAirport, {
                        tagList: filterValues.airportList,
                        handleTagCheck: function(checked, value) {
                            return setArrayFilter(checked, value, "airportList", setFilterValues);
                        },
                        dataStr: filter.outCityList
                    });
                }
            },
            {
                title: "여행 기간",
                Component: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(detailFilter_TravelDays, {
                        tagList: filterValues.travelDays,
                        handleTagCheck: function(checked, value) {
                            return setArrayFilter(checked, value, "travelDays", setFilterValues);
                        },
                        dataStr: filter.evNightList
                    });
                }
            },
            {
                title: "여행 예산 (1인 기준)",
                Component: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(detailFilter_TravelBudget, {
                        initialPrice: price,
                        minPricePlaceholder: filter.minPrice,
                        maxPricePlaceholder: filter.maxPrice,
                        handlePriceText: handlePriceText
                    });
                }
            },
            {
                title: "이용 교통",
                Component: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(detailFilter_Transportation, {
                        tagList: filterValues.transportation,
                        handleTagCheck: function(checked, value) {
                            return setArrayFilter(checked, value, "transportation", setFilterValues);
                        },
                        dataStr: filter.airList
                    });
                }
            }, 
        ];
        filter.featuresList && filterComponents.push({
            title: "상품 특징",
            Component: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(detailFilter_ProductFeature, {
                    tagList: filterValues.productFeature,
                    handleTagCheck: function(checked, value) {
                        return setArrayFilter(checked, value, "productFeature", setFilterValues);
                    },
                    dataStr: filter.featuresList
                });
            }
        });
        filter.promotionList && filterComponents.push({
            title: "프로모션",
            Component: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(detailFilter_Promotion, {
                    tagList: filterValues.promotion,
                    handleTagCheck: function(checked, value) {
                        return setArrayFilter(checked, value, "promotion", setFilterValues);
                    },
                    dataStr: filter.promotionList
                });
            }
        });
        filter.tmemberList && filterComponents.push({
            title: "여행구성원",
            Component: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(detailFilter_TravelMember, {
                    tagList: filterValues.travelMember,
                    handleTagCheck: function(checked, value) {
                        return setArrayFilter(checked, value, "travelMember", setFilterValues);
                    },
                    dataStr: filter.tmemberList
                });
            }
        });
        return filterComponents;
    };
    // 위치 고정
    if (!filters) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popup/* PopupContainer */.kZ, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlayProps), {
        title: "필터",
        size: "full",
        animate: "slideIn",
        padding: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrap, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* Area */.uN, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrap, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* TextInput */.oi, {
                            placeholder: "상품 상세 검색",
                            onChange: function(e) {
                                return setSearchGoods({
                                    goodsNm: e.target.value
                                });
                            },
                            value: searchGoods.goodsNm
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionArea, {
                    children: getFilterList().map(function(param, index) {
                        var title = param.title, Component = param.Component;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionItem, {
                            isToggle: activeIndex === index,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionContent, {
                                    onClick: function() {
                                        return toggleAccordion(index);
                                    },
                                    isToggle: activeIndex === index,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionTitle, {
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionMoreButton, {
                                            isToggle: activeIndex === index,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "더보기"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetail, {
                                    isActive: activeIndex === index,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {})
                                })
                            ]
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FloatArea, {
                    children: [
                        hasFilter && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterTagBox, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "필터"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: clearFilters,
                                    children: "전체삭제"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TagList, {
                                    children: [
                                        !!searchGoods.goodsNm && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TagListItem, {
                                            children: [
                                                searchGoods.goodsNm,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    onClick: function() {
                                                        return setSearchGoods({
                                                            goodsNm: ""
                                                        });
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "닫기"
                                                    })
                                                })
                                            ]
                                        }),
                                        reassignedFilters.map(function(param, filterIdx) {
                                            var stateName = param.stateName, state = param.state, setState = param.setState;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                children: Array.isArray(state) ? state.map(function(tag, stateIdx) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TagListItem, {
                                                        children: [
                                                            !OBJECT_ARRAY_FILTER_LIST.includes(stateName) ? tag : tag.name,
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                onClick: function() {
                                                                    return setState(state.filter(function(e) {
                                                                        return e !== tag;
                                                                    }));
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "닫기"
                                                                })
                                                            })
                                                        ]
                                                    }, stateIdx);
                                                }) : !!state.value && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TagListItem, {
                                                    children: [
                                                        state.text,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            onClick: function() {
                                                                return setState({
                                                                    value: "",
                                                                    text: ""
                                                                });
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "닫기"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }, filterIdx);
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_button/* TextButton */.Av, {
                            types: "confirm",
                            size: "submit",
                            text: "검색하기",
                            onClick: handleSubmit
                        })
                    ]
                })
            ]
        })
    }));
};
var LocalDetailFilter = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailFilter Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalDetailFilterComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var detailFilter = (LocalDetailFilter);

;// CONCATENATED MODULE: ./components/product/pages/localList/mobile/filter/LocalHeadFilter.tsx













var LocalLvl4ListComponent = function(param) {
    var _listStr = param.listStr, listStr = _listStr === void 0 ? "" : _listStr;
    var ref = (0,filterHook/* default */.Z)(), getFilter = ref.getFilter, addFilter = ref.addFilter, removeFilter = ref.removeFilter;
    var filters = getFilter();
    var lvl4List = [];
    var lvl4ListData = listStr.replaceAll("|", "").split("^");
    lvl4ListData.forEach(function(item, idx) {
        if (idx % 2 === 0) {
            var code = item;
            var name = lvl4ListData[idx + 1];
            lvl4List.push({
                code: code,
                name: name
            });
        }
    });
    var handleClick = function(e) {
        var _target = e.target, value = _target.value, checked = _target.checked;
        var text = e.target.parentNode.textContent;
        checked && addFilter("dspSid", value, text);
        !checked && removeFilter("dspSid", value);
    };
    if (!filters) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(productlistM/* AreaGridList */.oR, {
        children: lvl4List.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Checkbox */.XZ, {
                        id: "dspSid".concat(index),
                        onChange: handleClick,
                        checked: filters.some(function(v) {
                            return v.value === item.code;
                        }),
                        value: "".concat(item.code)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "dspSid".concat(index),
                        children: item.name
                    })
                ]
            }, index);
        })
    });
};
var LocalLvl4List = function(param) {
    var listStr = param.listStr;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "HeadFilter Lvl4List Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalLvl4ListComponent, {
            listStr: listStr
        })
    });
};
var LocalFilterBarComponent = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var _$ref = (0,filterHook/* default */.Z)(), getFilteringProduct = _$ref.getFilteringProduct, getFilter = _$ref.getFilter, setFilter = _$ref.setFilter;
    var productList = getFilteringProduct();
    var productCount = productList.length || 0; // 상품 갯수
    var key = "sort";
    var handleSelect = function(e) {
        var _$ref;
        var dataset = e.target.selectedOptions[0].dataset;
        var setArr = (_$ref = getFilter()) === null || _$ref === void 0 ? void 0 : _$ref.filter(function(v) {
            return v.key !== key;
        });
        dataset && setArr.push({
            key: key,
            value: dataset.value,
            text: dataset.text,
            asc: dataset.asc === "true"
        });
        setFilter(setArr);
    };
    var _$ref1 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = _$ref1[0];
    var openFilter = function() {
        open(function(overlayProps) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(detailFilter, (0,_object_spread/* default */.Z)({}, overlayProps));
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(productlistM/* FixedHeader */.$l, {
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(filter/* FilterTop */.DV, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(filter/* FilterLeftBox */.QC, {
                    children: [
                        "상품 ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                            children: productCount
                        }),
                        "개"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(filter/* FilterRightBox */.UQ, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(filter/* SelectBox */.jL, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                onChange: handleSelect,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "sortOrder",
                                        "data-asc": true,
                                        "data-value": "sortOrder",
                                        "data-text": "추천순",
                                        children: "추천순"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "rervTourlistCnt",
                                        "data-asc": false,
                                        "data-value": "rervTourlistCnt",
                                        "data-text": "인기순",
                                        children: "인기순"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "minPrice",
                                        "data-asc": true,
                                        "data-value": "minPrice",
                                        "data-text": "최저가순",
                                        children: "최저가순"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "maxPrice",
                                        "data-asc": false,
                                        "data-value": "minPrice",
                                        "data-text": "최고가순",
                                        children: "최고가순"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "rvwAvgScore",
                                        "data-asc": false,
                                        "data-value": "rvwAvgScore",
                                        "data-text": "평점순",
                                        children: "평점순"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(filter/* FilterButton */.Lb, {
                            type: "button",
                            onClick: openFilter,
                            children: "필터"
                        })
                    ]
                })
            ]
        })
    });
});
var LocalFilterBar = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "HeadFilter FilterBar Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalFilterBarComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            ref: ref
        }))
    });
});
var SUMMARY_FILTER_KEYS = [
    "outStartDateList" /* 출발 일정 월, 날짜 */ ,
    "wdayList" /* 출발 일정 요일*/ ,
    "outDeprtFgList" /* 출발 시간 */ ,
    "outCityDiviNm" /* 출발지(공항) */ ,
    "evDayCntList" /* 여행기간 */ ,
    "minPrice" /* 최소금액 */ ,
    "maxPrice" /* 최대금액 */ ,
    "airCd" /* 이용교통 */ ,
    "goodsFeaturesList" /* 상품특징 */ ,
    "goodsPromotion" /* 프로모션 */ ,
    "goodsTmember" /* 여행구성원 */ ,
    "goodsNm" /* 상품 상세 검색 */ , 
];
var LocalFilterSummaryComponent = function(param) {
    var isScroll = param.isScroll;
    var ref = (0,filterHook/* default */.Z)(), getFilter = ref.getFilter, removeFilter = ref.removeFilter, setFilter = ref.setFilter;
    var filters = getFilter();
    // filter 필드 병합 및 일부 필드 노출용 상태 관리
    var ref1 = (0,react.useState)([]), summaryFilters = ref1[0], setSummaryFilters = ref1[1];
    (0,react.useEffect)(function() {
        if (!filters) return;
        setSummaryFilters([]);
        // 전체 필터 중 일부 필터만 보여주기 위한 초기 데이터 설정
        SUMMARY_FILTER_KEYS.forEach(function(filterName) {
            // minPrice와 maxPrice는 전부 있거나 전부 없음
            if (filterName === "maxPrice") return;
            if (filterName === "minPrice") {
                var minPrice = filters.find(function(e) {
                    return e.key === "minPrice";
                });
                var maxPrice = filters.find(function(e) {
                    return e.key === "maxPrice";
                });
                if (!minPrice || !maxPrice) return;
                return setSummaryFilters(function(prev) {
                    return (0,_to_consumable_array/* default */.Z)(prev).concat([
                        {
                            key: "minMaxPrice",
                            value: "₩".concat(minPrice.text, " ~ ₩").concat(maxPrice.text),
                            text: "₩".concat(minPrice.text, " ~ ₩").concat(maxPrice.text)
                        }, 
                    ]);
                });
            }
            setSummaryFilters(function(prev) {
                return (0,_to_consumable_array/* default */.Z)(prev).concat((0,_to_consumable_array/* default */.Z)(filters.filter(function(e) {
                    return e.key === filterName;
                })));
            });
        });
    }, [
        filters
    ]);
    var removeAllFilters = function() {
        setFilter(getFilter().filter(function(item) {
            return item.key === "sort";
        }));
        setSummaryFilters([]);
    };
    var removeThisFilter = function(filter) {
        if (filter.key === "minMaxPrice") {
            var setArr = filters.filter(function(e) {
                return e.key !== "minPrice" && e.key !== "maxPrice";
            });
            setSummaryFilters(summaryFilters.filter(function(e) {
                return e.key !== "minMaxPrice";
            }));
            return setFilter(setArr);
        }
        setSummaryFilters(summaryFilters.filter(function(e) {
            return e.key !== filter.key;
        }));
        removeFilter(filter.key, filter.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(productlistM/* FilterTagHeader */.Jb, {
        isScroll: isScroll,
        children: !!summaryFilters.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(filter/* TagContainer */.x5, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(productlistM/* ResetButton */.JK, {
                    type: "button",
                    onClick: removeAllFilters,
                    children: "전체삭제"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(filter/* FilterTagWrap */.Ck, {
                    children: summaryFilters.map(function(filtr, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(filter/* FilterTag */.dB, {
                            children: [
                                filtr.text,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    onClick: function() {
                                        return removeThisFilter(filtr);
                                    },
                                    children: "닫기"
                                })
                            ]
                        }, idx);
                    })
                })
            ]
        })
    });
};
var LocalFilterSummary = function(param) {
    var isScroll = param.isScroll;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "HeadFilter FilterSummary Error ",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalFilterSummaryComponent, {
            isScroll: isScroll
        })
    });
};


// EXTERNAL MODULE: ./components/common/modal/share/Mobile.tsx + 3 modules
var share_Mobile = __webpack_require__(82864);
// EXTERNAL MODULE: ./components/common/goodsUtil.ts
var goodsUtil = __webpack_require__(68284);
// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
// EXTERNAL MODULE: ./framework/ui/mobile/icon/AirlineIcon.tsx
var AirlineIcon = __webpack_require__(27558);
;// CONCATENATED MODULE: ./components/product/pages/localList/mobile/goodsList/goods/LocalInfo.tsx









var LocalInfoComponent = function(param) {
    var product = param.product;
    var ref, ref1;
    // 여행 포인트 정보
    var infoWrapRef = (0,react.useRef)(null);
    var infoContentRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(false), showText = ref2[0], setShowText = ref2[1];
    var ref3 = (0,react.useState)(false), shouldShowToggleButton = ref3[0], setShouldShowToggleButton = ref3[1];
    var toggleText = function(e) {
        e.stopPropagation();
        setShowText(!showText);
        setShouldShowToggleButton(false);
    };
    (0,react.useEffect)(function() {
        var ref, ref1;
        // 여행 포인트 정보 상세 보기 핸들링
        var textHeight = (ref = infoContentRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight;
        var textWrapHeight = (ref1 = infoWrapRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientHeight;
        if (textHeight > textWrapHeight) {
            setShouldShowToggleButton(true);
        } else {
            setShouldShowToggleButton(false);
        }
    }, []);
    var goodsFeatureString = (ref = product.goodsFeaturesList) === null || ref === void 0 ? void 0 : ref.split("|").map(function(v) {
        return v.split(",")[0];
    }).join(", ").toString();
    // 출발요일
    var formatDateList = (ref1 = product.startFixOpenDtList) === null || ref1 === void 0 ? void 0 : ref1.split(",").map(function(date) {
        return dayjs_min_default()(date).format("MM.DD");
    });
    // 이용교통
    var companyList = (0,goodsUtil/* airOrderSort */.Y$)(product);
    var trArray = companyList.slice(0, 2);
    var otherCdCnt = companyList.length - 2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(productlistM/* ProductTitle */.tc, {
                children: product.goodsNm
            }),
            product.goodsTpointContents && /*#__PURE__*/ (0,jsx_runtime.jsx)(productlistM/* InfoGroup */.aJ, {
                direction: "column",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlistM/* InfoGroupContent */.VJ, {
                    show: showText,
                    ref: infoWrapRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                            children: goodsFeatureString && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                children: goodsFeatureString
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: infoContentRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: product.goodsTpointContents.replace(/\n/g, "<br>")
                                }
                            })
                        }),
                        shouldShowToggleButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(productlistM/* BenefitButtonWrap */.kt, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(productlistM/* BenefitButton */.Xk, {
                                type: "button",
                                onClick: toggleText,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "더보기"
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlistM/* Summary */.ER, {
                children: [
                    product.startFixOpenDtList && /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                children: "출발확정"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(productlistM/* SummaryDeparture */.Uz, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    children: formatDateList.slice(0, 10).join(" / ")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                children: "출발기간"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                children: "".concat(dayjs_min_default()(product.minStartDt).format("YYYY.MM.DD"), " ~ ").concat(dayjs_min_default()(product.maxStartDt).format("YYYY.MM.DD"))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                children: "출발요일"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                children: (0,goodsUtil/* StartWeek */.xN)(product)
                            })
                        ]
                    }),
                    product.airCd && /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                children: "이용교통"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlistM/* Transportation */.gj, {
                                    children: [
                                        trArray.map(function(trString, index) {
                                            var trInfoArray = trString.split(",");
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AirlineIcon/* default */.Z, {
                                                img: "".concat(config_public/* default.ENV_STATIC_CDN_URL */.Z.ENV_STATIC_CDN_URL, "/images/air/").concat(trInfoArray[1], ".png"),
                                                title: trInfoArray[0]
                                            }, index);
                                        }),
                                        otherCdCnt > 0 && " 외 ".concat(otherCdCnt)
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var LocalInfo = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "Product Info Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalInfoComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var goods_LocalInfo = (LocalInfo);

// EXTERNAL MODULE: ./node_modules/@yb/ui/mobile/common/Flag/index.cjs
var Flag = __webpack_require__(19963);
;// CONCATENATED MODULE: ./components/product/pages/localList/mobile/goodsList/goods/LocalPrice.tsx







var LocalPriceComponent = function(param) {
    var product = param.product;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(productlistM/* PriceWrap */.PS, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(productlistM/* PriceBox */.bz, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                align: "end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlistM/* PriceTag */.WR, {
                        children: [
                            product.goodsPromotion && /*#__PURE__*/ (0,jsx_runtime.jsx)(productlistM/* PromotionFlag */.kN, {
                                children: product.goodsPromotion.split(",")[1]
                            }),
                            product.couponYn === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flag/* Flag */.W, {
                                $type: "promotion",
                                $flag: "coupon",
                                text: "쿠폰할인"
                            })
                        ]
                    }),
                    product.ypdYn === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlistM/* BeforePrice */.t0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(product.ypdPrice)
                            }),
                            "원"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlistM/* Price */.tA, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(product.minPrice)
                            }),
                            "원~"
                        ]
                    })
                ]
            })
        })
    });
};
var LocalPrice = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "Product Price Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalPriceComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var goods_LocalPrice = (LocalPrice);

// EXTERNAL MODULE: ./components/common/flag/Mobile.tsx
var flag_Mobile = __webpack_require__(28403);
// EXTERNAL MODULE: ./framework/ui/mobile/thumbnail/ProductListThumbnail.tsx + 1 modules
var ProductListThumbnail = __webpack_require__(99311);
// EXTERNAL MODULE: ./node_modules/@yb/ui/mobile/common/Noimage/index.cjs
var Noimage = __webpack_require__(65790);
;// CONCATENATED MODULE: ./components/product/pages/localList/mobile/goodsList/goods/LocalThumbnail.tsx












var LocalThumbnailComponent = function(param) {
    var selectedProduct = param.selectedProduct, selectToCompare = param.selectToCompare, product = param.product, handleShare = param.handleShare;
    var router = (0,next_router.useRouter)();
    var _query = router.query, menu = _query.menu, dspSid = _query.dspSid;
    if (!menu || !dspSid) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductListThumbnail/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(productlistM/* ImageItem */.vE, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Noimage/* Noimage */.T, {
                    width: "100%",
                    height: "200px",
                    src: product.imageThum3,
                    alt: "상품 이미지"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(productlistM/* ProductCheck */.IH, {
                type: "checkbox",
                checked: selectedProduct.some(function(value) {
                    return value === product.goodsCd;
                }),
                onChange: selectToCompare,
                value: product.goodsCd
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlistM/* CircleButtonWrap */.hN, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(flag_Mobile/* FlagYellowPick */.a8, {
                        pickYn: product.pickYn
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(flag_Mobile/* FlagYellowPangdeal */.hY, {
                        ypdYn: product.ypdYn
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(flag_Mobile/* FlagPromotion */.tI, {
                        goodsCd: product.goodsCd
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlistM/* StackWrap */.c7, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: (0,goodsUtil/* hashTagManufacture */.Cx)(product.keyWordList, 3)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(productlistM/* StarImg */.$H, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                children: product.rvwAvgScore || "-"
                            }),
                            "/ 5",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_button/* ShareButton */.Tz, {
                                onClick: function() {
                                    return handleShare(product.goodsCd);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "공유하기"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlistM/* TagGroup */.QS, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(flag_Mobile/* FlagGoodsCd */.G, {
                        goodsCd: product.goodsCd
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(flag_Mobile/* FlagGoodsTp */.B2, {
                        goodsTp: product.goodsTp
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(flag_Mobile/* FlagGoodsBrandCd */.hA, {
                        goodsBrandCd: product.goodsBrandCd
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(flag_Mobile/* FlagGoodsTmember */.$4, {
                        goodsTmember: product.goodsTmember
                    })
                ]
            })
        ]
    });
};
var LocalThumbnail = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "Product Thumbnail Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalThumbnailComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var goods_LocalThumbnail = (LocalThumbnail);

;// CONCATENATED MODULE: ./components/product/pages/localList/mobile/goodsList/goods/index.tsx













var LocalGoods = function(param) {
    var product = param.product, selectedProduct = param.selectedProduct, selectToCompare = param.selectToCompare, handleDeparturePopup = param.handleDeparturePopup;
    var ref, ref1, ref2;
    // 비교 상품 선택 확인
    var isChecked = selectedProduct.includes(product.goodsCd);
    // 공유하기
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref3[0];
    var router = (0,next_router.useRouter)();
    var dspSid = "".concat((ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.dspSid) === null || ref1 === void 0 ? void 0 : ref1.slice(0, -2), "00");
    var menu = (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.menu;
    var handleShare = function(goodsCd) {
        open(function(prop) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(share_Mobile/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                parameter: "menu=".concat(menu, "&dspSid=").concat(dspSid, "&goodsCd=").concat(goodsCd)
            }));
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlistM/* ProductListItem */.A5, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(goods_LocalThumbnail, {
                selectedProduct: selectedProduct,
                selectToCompare: selectToCompare,
                product: product,
                handleShare: handleShare
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(goods_LocalInfo, {
                product: product
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(goods_LocalPrice, {
                product: product
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* CompareBox */.u5, {
                state: isChecked,
                onClick: function(e) {
                    e.stopPropagation();
                    selectToCompare((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, e), {
                        target: {
                            value: product.goodsCd,
                            checked: false
                        }
                    }));
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(productlistM/* ProductListItemData */.rd, {
                onClick: function(e) {
                    e.preventDefault();
                    handleDeparturePopup(product.goodsCd);
                }
            })
        ]
    });
};
/* harmony default export */ var goods = (LocalGoods);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./components/style/productlist/compareproductM.tsx

function compareproductM_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	width: 100%;\n	table {\n		border-top: none;\n		border-collapse: separate;\n		border-spacing: 0;\n		th {\n			text-align: center;\n		}\n		td {\n			vertical-align: baseline;\n			word-break: break-all;\n			+ td {\n				border-left: 1px solid var(--line-color);\n			}\n		}\n		tr {\n			&:last-child td {\n				background-color: var(--disabled-color);\n			}\n		}\n	}\n"
    ]);
    compareproductM_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function compareproductM_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: sticky;\n	z-index: 10;\n	width: 100%;\n	height: auto;\n	background-color: #fff;\n	&:first-of-type {\n		top: 60px;\n		> th {\n			border-top: 1px solid #000;\n			border-bottom: 1px solid var(--line-color);\n		}\n	}\n	&:nth-of-type(2) {\n		top: 115px;\n		border-bottom: 1px solid var(--line-color);\n	}\n"
    ]);
    compareproductM_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function compareproductM_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: block;\n"
    ]);
    compareproductM_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function compareproductM_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	gap: 10px;\n"
    ]);
    compareproductM_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function compareproductM_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	gap: 5px;\n"
    ]);
    compareproductM_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function compareproductM_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-wrap: wrap;\n	gap: 0 5px;\n	em {\n		font-size: 18px;\n		font-weight: bold;\n		color: var(--emp-color);\n	}\n"
    ]);
    compareproductM_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function compareproductM_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	align-items: center;\n	gap: 10px;\n	padding: 15px 0;\n\n	button {\n		width: 70%;\n	}\n"
    ]);
    compareproductM_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var compareproductM_Wrap = index_esm/* default.div */.ZP.div(compareproductM_templateObject());
var FixedArea = index_esm/* default.tr */.ZP.tr(compareproductM_templateObject1());
var Tag = index_esm/* default.div */.ZP.div(compareproductM_templateObject2());
var PriceList = index_esm/* default.ul */.ZP.ul(compareproductM_templateObject3());
var PriceListItem = index_esm/* default.li */.ZP.li(compareproductM_templateObject4());
var Price = index_esm/* default.span */.ZP.span(compareproductM_templateObject5());
var BtnBlock = index_esm/* default.div */.ZP.div(compareproductM_templateObject6());


// EXTERNAL MODULE: ./framework/ui/mobile/table/index.tsx
var table = __webpack_require__(72186);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/goods/useGoodsCompare.ts
var useGoodsCompare = __webpack_require__(82834);
;// CONCATENATED MODULE: ./components/product/pages/localList/mobile/popup/CompareProductsPopup.tsx














var CompareProductsPopupComponent = function(_param) {
    var selected = _param.selected, showDepartureDayPopup = _param.showDepartureDayPopup, overlayProps = (0,_object_without_properties/* default */.Z)(_param, [
        "selected",
        "showDepartureDayPopup"
    ]);
    var data = (0,useGoodsCompare/* default */.ZP)(selected.toString()).data;
    var router = (0,next_router.useRouter)();
    var compareList = data === null || data === void 0 ? void 0 : data.body.compareList;
    (0,useTagging/* useTaggingLoad */.q)("pkg_compare_goodsCd", compareList);
    var ProductName = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FixedArea, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                        scope: "col",
                        colSpan: 2,
                        children: "상품명"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FixedArea, {
                    children: compareList.map(function(product, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flag/* Flag */.W, {
                                        $type: "code",
                                        text: product.goodsCd
                                    })
                                }),
                                product.goodsNm
                            ]
                        }, index);
                    })
                })
            ]
        });
    };
    var ProductFee = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                        scope: "col",
                        colSpan: 2,
                        children: "상품가"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                    children: compareList.map(function(product, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceList, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceListItem, {
                                        children: [
                                            "성인",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Price, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                                children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(product.minAdtPrice)
                                                            }),
                                                            "원"
                                                        ]
                                                    }),
                                                    "~",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                                children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(product.maxAdtPrice)
                                                            }),
                                                            "원"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceListItem, {
                                        children: [
                                            "아동",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Price, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                                children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(product.minChdPrice)
                                                            }),
                                                            "원"
                                                        ]
                                                    }),
                                                    "~",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                                children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(product.maxChdPrice)
                                                            }),
                                                            "원"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceListItem, {
                                        children: [
                                            "유아",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Price, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                                children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(product.minInfPrice)
                                                            }),
                                                            "원"
                                                        ]
                                                    }),
                                                    "~",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                                children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(product.maxInfPrice)
                                                            }),
                                                            "원"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, index);
                    })
                })
            ]
        });
    };
    var TravelPeriod = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                        scope: "col",
                        colSpan: 2,
                        children: "여행기간"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                    children: compareList.map(function(product, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            children: product.evNightNm
                        }, index);
                    })
                })
            ]
        });
    };
    var VisitCities = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                        scope: "col",
                        colSpan: 2,
                        children: "방문도시"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                    children: compareList.map(function(product, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            children: product.vcityInfo
                        }, index);
                    })
                })
            ]
        });
    };
    var TravelPoints = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: compareList.some(function(e) {
                return !!e.prdExpl;
            }) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                            scope: "col",
                            colSpan: 2,
                            children: "여행포인트"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                        children: compareList.map(function(product, index) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("td", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    dangerouslySetInnerHTML: {
                                        __html: (ref = product.prdExpl) === null || ref === void 0 ? void 0 : ref.replace(/\r\n/g, "<br/>")
                                    }
                                })
                            }, index);
                        })
                    })
                ]
            })
        });
    };
    var CompareActions = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                children: compareList.map(function(product, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BtnBlock, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_button/* TextButton */.Av, {
                                    size: "default",
                                    text: "출발일 보기",
                                    onClick: function() {
                                        return showDepartureDayPopup(product.goodsCd);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_button/* TextButton */.Av, {
                                    size: "default",
                                    types: "basic",
                                    text: "상품 상세보기",
                                    onClick: function() {
                                        return router.push(product.webLinkUrl);
                                    }
                                })
                            ]
                        })
                    }, index);
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: compareList && /*#__PURE__*/ (0,jsx_runtime.jsx)(popup/* PopupContainer */.kZ, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlayProps), {
            title: "비교하기",
            padding: false,
            size: "full",
            animate: "slideIn",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(compareproductM_Wrap, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* Table */.iA, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                            children: "상품 비교하기"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                    style: {
                                        width: "50%"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                    style: {
                                        width: "50%"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductName, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductFee, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelPeriod, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VisitCities, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelPoints, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareActions, {})
                            ]
                        })
                    ]
                })
            })
        }))
    });
};
var CompareProductsPopup = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "Popup CompareProducts Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareProductsPopupComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var popup_CompareProductsPopup = (CompareProductsPopup);

// EXTERNAL MODULE: ./framework/ui/mobile/layout/LoadingBox.tsx
var LoadingBox = __webpack_require__(53521);
// EXTERNAL MODULE: ./framework/ui/mobile/layout/WarningBox.tsx
var WarningBox = __webpack_require__(58219);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/goods/useGoodsByMenu.ts
var useGoodsByMenu = __webpack_require__(73225);
;// CONCATENATED MODULE: ./components/product/pages/localList/mobile/goodsList/LocalGoodsList.tsx




















var GoodsListComponent = function() {
    var ref;
    var router = (0,next_router.useRouter)();
    var dspSid = (ref = router.query) === null || ref === void 0 ? void 0 : ref.dspSid;
    var goodsListFetch = (0,useGoodsByMenu/* default */.Z)(dspSid);
    var getFilteringProduct = (0,filterHook/* default */.Z)().getFilteringProduct;
    var goodsList = getFilteringProduct();
    var ref1 = (0,react.useState)([]), selectedProduct = ref1[0], setSelectedProduct = ref1[1];
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("pkg_select_prod_list").taggingClick;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref2[0];
    /** scrollRestore 상품 클릭 위치 저장 */ var ref3 = (0,useScrollRestoration/* scrollRestore */.L)(), getRestoreData = ref3.getRestoreData, setRestoreData = ref3.setRestoreData;
    // 비교 상품 선택
    var selectToCompare = function(e) {
        var _target = e.target, value = _target.value, checked = _target.checked;
        var isChecked = selectedProduct.includes(value);
        if (selectedProduct.length >= 2 && !isChecked) {
            return MessageUtil.alert("비교상품은 총 2개까지 선택이 가능합니다.");
        }
        if (selectedProduct.length < 2 || isChecked) {
            if (checked) {
                setSelectedProduct((0,_to_consumable_array/* default */.Z)(selectedProduct).concat([
                    value
                ]));
            } else {
                setSelectedProduct(selectedProduct.filter(function(v) {
                    return v !== value;
                }));
            }
        }
    };
    /** 출발일 팝업 핸들러 */ var handleDeparturePopup = function(goodsCd) {
        /** scrollRestore 상품 클릭 위치 저장 */ setRestoreData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getRestoreData()), {
            top: document.scrollingElement.scrollTop
        }));
        // tagging
        taggingClick({
            goodsCd: goodsCd
        });
        open(function(popupProps) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListPopup/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, popupProps), {
                goodsCd: goodsCd
            }));
        });
    };
    /** 비교상품 팝업 핸들러 */ var compareProducts = function() {
        open(function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(popup_CompareProductsPopup, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                selected: selectedProduct,
                showDepartureDayPopup: handleDeparturePopup
            }));
        });
    };
    var renderGoodsList = function() {
        if (goodsListFetch.isFetching) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingBox/* default */.Z, {});
        }
        if (goodsList.length === 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningBox/* default */.Z, {
                children: "해당하는 상품이 존재하지 않습니다."
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(productlistM/* ProductList */.cm, {
                children: goodsList.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(goods, {
                        product: item,
                        selectedProduct: selectedProduct,
                        selectToCompare: selectToCompare,
                        handleDeparturePopup: handleDeparturePopup
                    }, index);
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            renderGoodsList(),
            selectedProduct.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlistM/* CompareButton */.mx, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_button/* TextButton */.Av, {
                        onClick: function() {
                            return setSelectedProduct([]);
                        },
                        width: "basic",
                        size: "submit",
                        types: "basic",
                        text: "선택 해제"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_button/* TextButton */.Av, {
                        onClick: compareProducts,
                        width: "basic",
                        size: "submit",
                        types: "confirm",
                        text: "상품 비교"
                    })
                ]
            })
        ]
    });
};
var LocalGoodsList = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "Product List Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoodsListComponent, {})
    });
};
/* harmony default export */ var goodsList_LocalGoodsList = (LocalGoodsList);

// EXTERNAL MODULE: ./hooks/services/queries/bff/global/useGlobalGoodsFlag.ts
var useGlobalGoodsFlag = __webpack_require__(64630);
// EXTERNAL MODULE: ./store/index.ts + 2 modules
var store = __webpack_require__(79390);
// EXTERNAL MODULE: ./store/store-filter.ts
var store_filter = __webpack_require__(57467);
;// CONCATENATED MODULE: ./pages/product/localList.m.page.tsx

























var Page = function(param) {
    var filterData = param.filterData;
    var ref, ref1, ref2, ref3, ref4;
    var router = (0,next_router.useRouter)();
    var dspSid = router.query.dspSid;
    var goodsCd = router.query.goodsCd;
    var goodsMonth = (ref = router.query) === null || ref === void 0 ? void 0 : ref.goodsMonth;
    var goodsAirCd = (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.goodsAirCd;
    var ref5 = (0,useGoodsFilter/* default */.ZP)(dspSid, {
        placeholderData: {
            body: filterData
        }
    }), data = ref5.data, isError = ref5.isError;
    if (isError) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "에러가 발생했습니다."
        });
    }
    var filter = data === null || data === void 0 ? void 0 : data.body;
    // goodsFlag 미리 호출 (FlagPromotion 에서 사용)
    (0,useGlobalGoodsFlag/* default */.Z)();
    var ref6 = (0,filterHook/* default */.Z)(), getFilteringProduct = ref6.getFilteringProduct, setFilter = ref6.setFilter;
    /* filterStore 초기화 */ var filterStore = (0,store/* useAppSelector */.CG)(function(state) {
        return state.goodsFilterStore;
    });
    var dispatch = (0,store/* useAppDispatch */.TL)();
    (0,react.useEffect)(function() {
        var storeDspSid = filterStore.goodsFilter ? Object.keys(filterStore === null || filterStore === void 0 ? void 0 : filterStore.goodsFilter)[0] : {};
        if (dspSid && dspSid !== storeDspSid) {
            var storeInit = (0,_define_property/* default */.Z)({}, dspSid, [
                {
                    text: "추천순",
                    value: "sortOrder",
                    key: "sort",
                    asc: true
                }
            ]);
            dispatch((0,store_filter/* initGoodsFilter */.yj)()); /* 데이터 초기화*/ 
            dispatch((0,store_filter/* setGoodsFilter */.Hv)(storeInit)); /* dspSid 세팅 */ 
        }
    }, [
        router
    ]);
    /** queryString에 goodsAirCd 이용 교통 세팅 */ (0,react.useEffect)(function() {
        var ref;
        if (!goodsAirCd || !(filter === null || filter === void 0 ? void 0 : filter.airList)) return;
        var ref1;
        var airListData = (ref1 = (ref = filter.airList) === null || ref === void 0 ? void 0 : ref.replaceAll("|", "").split("^")) !== null && ref1 !== void 0 ? ref1 : [];
        var airList = [];
        for(var i = 0; i < airListData.length; i += 2){
            var code = airListData[i];
            var name = airListData[i + 1];
            airList.push({
                code: code,
                name: name
            });
        }
        var arrAirCd = goodsAirCd.split(",");
        var setArr = JSON.parse(JSON.stringify(filterStore.goodsFilter[dspSid])) || [];
        var newItems = arrAirCd.reduce(function(acc, value) {
            var ref;
            var text = (ref = airList.find(function(item) {
                return item.code === value;
            })) === null || ref === void 0 ? void 0 : ref.name;
            if (text) acc.push({
                key: "airCd",
                value: value,
                text: text
            });
            return acc;
        }, []);
        // 최종 배열: 기존 필터 + 새로 추가된 항공사 필터
        var merged = (0,_to_consumable_array/* default */.Z)(setArr).concat((0,_to_consumable_array/* default */.Z)(newItems));
        // 중복 제거
        var deduped = merged.filter(function(item, index, self) {
            return item.key !== "airCd" || self.findIndex(function(v) {
                return v.key === "airCd" && v.value === item.value;
            }) === index;
        });
        setFilter(deduped);
    }, [
        goodsAirCd,
        filter === null || filter === void 0 ? void 0 : filter.airList
    ]);
    // header scroll
    var FilterRef = (0,react.useRef)();
    var ref7 = (0,react.useState)(false), direction = ref7[0], setDirection = ref7[1];
    var lastScroll = 0;
    var controlDirection = function() {
        if (window.scrollY > lastScroll) {
            setDirection(false);
        } else {
            setDirection(true);
        }
        lastScroll = window.scrollY;
    };
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), viewProduct = ref8[0];
    var productList = getFilteringProduct();
    var hasRouterGoods = productList.some(function(v) {
        return v.goodsCd === goodsCd;
    });
    /** scrollRestore 상품 클릭 위치 저장 */ var getRestoreData = (0,useScrollRestoration/* scrollRestore */.L)().getRestoreData;
    var restoreData = getRestoreData() || {
        top: 0,
        goodsCd: null,
        startMonth: null
    };
    var hasRestoreGoodsCd = productList.some(function(v) {
        return v.goodsCd === restoreData.goodsCd;
    });
    (0,react.useEffect)(function() {
        // 상품 클릭 위치 저장 실행
        if (hasRestoreGoodsCd) viewProduct(function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListPopup/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                goodsCd: restoreData.goodsCd,
                startMonth: restoreData.startMonth
            }));
        });
        else if (goodsCd && hasRouterGoods) viewProduct(function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListPopup/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                goodsCd: goodsCd,
                startMonth: goodsMonth && dayjs_min_default()(goodsMonth).isValid() && goodsMonth
            }));
        });
    }, [
        hasRouterGoods,
        hasRestoreGoodsCd,
        goodsMonth
    ]);
    /* 상품 클릭 위치 스크롤 위치 이동 */ (0,react.useEffect)(function() {
        if (!getRestoreData()) return;
        scrollTo({
            top: restoreData.top
        });
    }, []);
    (0,react.useEffect)(function() {
        // 여행 포인트
        window.addEventListener("scroll", controlDirection);
        return function() {
            window.removeEventListener("scroll", controlDirection);
        };
    }, []);
    if (!filter) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    (0,useTagging/* useTaggingLoad */.q)("pkg_view_goodsCdList");
    var ref9;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(productlistM/* Wrap */.Eq, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header_Mobile/* default */.Z, {
                        category: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalLvl4List, {
                        listStr: filter.lvl4List
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalFilterBar, {
                        ref: FilterRef
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalFilterSummary, {
                        isScroll: direction
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(goodsList_LocalGoodsList, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile/* default */.Z, {})
                ]
            }),
            ((ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.goodsCd) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GTMTags/* default */.Z, {
                    menu: (ref9 = (ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.menu) !== null && ref9 !== void 0 ? ref9 : "",
                    goodsCd: (ref4 = router.query) === null || ref4 === void 0 ? void 0 : ref4.goodsCd
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var localList_m_page = (Page);


/***/ }),

/***/ 99653:
/***/ (function(module) {

module.exports = "/_next/static/images/ico_spr.66pUW1wQ.png";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2335,1712,1863,431,8235,6322,9272,3432,5936,9774,2888,179], function() { return __webpack_exec__(80819); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);